<template>
    <!-- 开票管理 -->

    <div class="wrapper">
        <div>
            <!-- 复制票面数据弹出 -->
            <el-dialog title="复制票面" :visible.sync="copydiag" width="95%" append-to-body :close-on-click-modal="false">
                <div class="area1">
                    <div class="alledit" style="font-size:20px; padding:10px">
                        <el-input
                            style="width:360px"
                            placeholder="请输入客户编号、客户名称、纳税人识别号、银行账号、地址、电话"
                            prefix-icon="el-icon-search"
                            v-model="likeSearchcopy"
                            @input="forserchcopy()"
                        ></el-input>
                    </div>
                    <div class="alledit-table" style="margin-left: 10px;margin-right: 10px;">
                        <!--@row-click="clickRow"  @row-dblclick="doubleClickRow"-->
                        <el-table  :data="tableData_copy" tooltip-effect="dark" style="width: 100%" height="250">
                            <!--<el-table-column width="25" label="">-->
                                <!--<template slot-scope="scope">-->
                                    <!--<el-radio-->
                                            <!--v-model="radio_copy"-->
                                            <!--:label="scope.row.id"-->
                                            <!--@change="radiochangecopy(scope.row)"-->
                                    <!--&gt;<span></span></el-radio>-->
                                <!--</template>-->
                            <!--</el-table-column>-->
                            <!--<el-table-column  width="50" label="序号">-->
                                <!--<template slot-scope="scope">-->
                                    <!--<span>{{scope.$index+1}}</span>-->
                                <!--</template>-->
                            <!--</el-table-column>-->
                            <el-table-column width="55" label="序号">
                                <template slot-scope="scope">
                                    <el-radio
                                        v-model="radio_copy"
                                        :label="scope.$index + 1"
                                        @change="radiochangecopy(scope.row)"
                                    ></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="stateall.docNo" width="200" label="单据号"></el-table-column>
                            <el-table-column prop="stateall.docDate" width="200" label="单据日期" align="center">
                                <template slot-scope="scope">
                                    <span>{{ yyyyMMdd(scope.row.stateall.docDate) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="faply" label="发票来源" width="100" align="center">
                                <template slot-scope="scope">
                                    <!-- 发票来源 发票来源 1：文件导入；2：手工录入；3：客户接口 4:税控同步5:支付开票6:扫码开票 -->
                                    <p v-if="scope.row.stateall.faply == '1'">文件导入</p>
                                    <p v-if="scope.row.stateall.faply == '2'">手工录入</p>
                                    <p v-if="scope.row.stateall.faply == '3'">客户接口</p>
                                    <p v-if="scope.row.stateall.faply == '4'">税控同步</p>
                                    <p v-if="scope.row.stateall.faply == '5'">支付开票</p>
                                    <p v-if="scope.row.stateall.faply == '6'">扫码开票</p>
                                    <p v-if="scope.row.stateall.faply == '7'">红冲重开</p>
                                    <p v-if="scope.row.stateall.faply == '8'">作废重开</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="发票类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <p v-if="scope.row.stateall.choosetitleindex == '026'">电子普票</p>
                                    <p v-if="scope.row.stateall.choosetitleindex == '028'">电子专票</p>
                                    <p v-if="scope.row.stateall.choosetitleindex == '004'">纸质专票</p>
                                    <p v-if="scope.row.stateall.choosetitleindex == '007'">纸质普票</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ruleFormb.customerName" label="购方名称" width="200" align="center"></el-table-column>
                            <el-table-column prop="invoiceNo" label="发票号码" width="100" align="center"></el-table-column>
                            <el-table-column prop="totalall.pricetotal" label="金额" align="right">
                                <template slot-scope="scope">
                                    <span>{{ toThousands(Amountformat(scope.row.totalall.pricetotal)) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="totalall.taxtotal" label="税额" align="right">
                                <template slot-scope="scope">
                                    <span>{{ toThousands(Amountformat(scope.row.totalall.taxtotal)) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否清单" v-if="choosetitleindex == '007' || choosetitleindex == '004'">
                                <template slot-scope="scope">
                                    <span>{{ toThousands(Amountformat(scope.row.totalall.taxtotal)) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="开票日期" align="center" width="150">
                                <template slot-scope="scope">
                                    <span>{{ yyyyMMdd(scope.row.billingDate) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="documentStatus" label="单据状态" width="100">
                                <template slot-scope="scope">
                                    <!-- 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 -->
                                    <p v-if="scope.row.documentStatus == '-1'" style="color:#BEBEBE">草稿</p>
                                    <p v-if="scope.row.documentStatus == '0'">待审核</p>
                                    <p v-if="scope.row.documentStatus == '1'" style="color:#00DC16">已审核</p>
                                    <p v-if="scope.row.documentStatus == '2'" style="color:#EE0101">待开票</p>
                                    <p v-if="scope.row.documentStatus == '3'" style="color:#2F66FC">开票中</p>
                                    <p v-if="scope.row.documentStatus == '4'" style="color:#FF8000">已开票</p>
                                    <p v-if="scope.row.documentStatus == '5'" style="color:#FF8000">已作废</p>
                                    <p v-if="scope.row.documentStatus == '6'" style="color:#FF8000">已红冲</p>
                                    <p v-if="scope.row.documentStatus == '7'" style="color:#BEBEBE">开票失败</p>
                                    <p v-if="scope.row.documentStatus == '8'" style="color:#00DC16">暂不开票</p>
                                    <p v-if="scope.row.documentStatus == '9'" style="color:#00DC16">已退票</p>
                                    <p v-if="scope.row.documentStatus == '10'" style="color:#00DC16">已合并</p>
                                    <p v-if="scope.row.documentStatus == '21'" style="color:#00DC16">作废关闭中</p>
                                    <p v-if="scope.row.documentStatus == '22'" style="color:#00DC16">作废重开中</p>
                                    <p v-if="scope.row.documentStatus == '23'" style="color:#00DC16">作废锁定</p>
                                    <p v-if="scope.row.documentStatus == '31'" style="color:#00DC16">未开发票冲销</p>
                                    <p v-if="scope.row.documentStatus == '32'" style="color:#00DC16">已开发票冲销</p>
                                    <p v-if="scope.row.documentStatus == '33'" style="color:#00DC16">作废冲销</p>
                                    <p v-if="scope.row.documentStatus == '34'" style="color:#00DC16">无需开票</p>
                                    <p v-if="scope.row.documentStatus == '34'" style="color:#00DC16">待作废</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="stateall.zhidr" label="制单人" width="200" align="center"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChangecopy"
                        @current-change="handleCurrentChangecopy"
                        :page-sizes="[10, 20, 30, 40, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalcopy"
                    ></el-pagination>
                    <!-- 按钮 -->
                    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
                        <el-button @click="copydiag = false">取 消</el-button>
                        <el-button type="primary" @click="forsurecopy">确 定</el-button>
                    </span>
                    <div style="height: 10px;"></div>
                </div>
            </el-dialog>
            <!-- 折扣行弹层区 -->
            <el-dialog append-to-body :visible.sync="dialogVisible_reduce" width="45%" :close-on-click-modal="false" title="折扣行">
                <div style="display: flex;justify-content: center;">
                    <div>
                        <div style="margin-top: 15px;font-size:16px;">
                            当前选择
                            <span style="color: #2F66FC;">{{ zkhang }}</span>
                            行，金额共计
                            <span v-if="zktotal > 0" style="color: #2F66FC;">{{ Amountformat(zktotal) }}</span>
                            <span v-else>0</span>
                        </div>
                        <!-- 折扣行表单区 -->
                        <div style="margin-top: 20px;">
                            <el-form ref="form_money" :model="form_money" label-width="120px">
                                <el-form-item label="折  扣  率（%）:" style="font-size: 16px;height: 45px;">
                                    <el-input v-model="form_money.DiscountRate" style="width: 300px;" @change="changemoney"></el-input>
                                </el-form-item>
                                <el-form-item label="折扣金额（￥）:" style="font-size: 16px;">
                                    <el-input v-model="form_money.DiscountMoney" style="width: 300px;" @change="changelv"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;margin-top: 20px;">
                    <el-button @click="dialogVisible_reduce = false">取 消</el-button>
                    <el-button type="primary" @click="forsave" style="margin-left: 50px;">保存</el-button>
                </span>
            </el-dialog>
            <!-- 差额征税差额设置弹出 -->
            <el-dialog append-to-body :visible.sync="chaediag" width="45%" :close-on-click-modal="false">
                <div style="font-size:20px; #CCCCCC;color:#2F66FC;">差额设置</div>

                <div style="margin-top: 20px;">
                    <el-form :model="form_chae" label-width="120px">
                        <el-form-item label="含税销售额:" style="font-size: 16px;height: 45px;">
                            <el-input v-model="form_chae.chooseMoney" style="width: 300px;" @change="changemoney"></el-input>
                        </el-form-item>
                        <el-form-item label="扣 除 额 :" style="font-size: 16px;">
                            <el-input v-model="form_chae.kouchu" style="width: 300px;" @change="changelv"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;margin-top: 20px;">
                    <el-button @click="chaediag = false">取 消</el-button>
                    <el-button type="primary" @click="savechae" style="margin-left: 50px;">保存</el-button>
                </span>
            </el-dialog>
            <!-- 销方数据弹出 -->
            <el-dialog title="销方数据" :visible.sync="dialogFormtoxiao" width="95%" append-to-body :close-on-click-modal="false">
                <div class="area1">
                    <div class="alledit-table">
                        <el-table ref="multipleTable" :data="tableData_xiao" tooltip-effect="dark" style="width: 100%" height="250">
                            <el-table-column width="55" label="序号">
                                <template slot-scope="scope">
                                    <el-radio
                                        v-model="radio_xiao"
                                        :label="scope.$index + 1"
                                        @change="radiochangexiao(scope.row)"
                                    ></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="code" label="销售方编号"></el-table-column>
                            <el-table-column prop="name" label="销售方名称"></el-table-column>
                            <el-table-column prop="taxNumber" label="销售方名称纳税人识别号"></el-table-column>
                            <el-table-column prop="addressPhone" label="销售方名称地 址、电 话"></el-table-column>
                            <el-table-column prop="bankAccount" label="销售方名称开户行及账号"></el-table-column>
                        </el-table>
                    </div>
                    <!-- 分页 -->
                    <!-- 按钮 -->
                    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
                        <el-button @click="dialogFormtoxiao = false">取 消</el-button>
                        <el-button type="primary" @click="forsurexf">确 定</el-button>
                    </span>
                    <div style="height: 10px;"></div>
                </div>
            </el-dialog>
            <!-- 客户主数据弹出 -->
            <el-dialog title="客户主数据" :visible.sync="dialogFormVisible_Name" width="95%" append-to-body :close-on-click-modal="false">
                <div class="area1">
                    <div class="alledit" style="font-size:20px; padding:10px">
                        <el-input
                            style="width:360px"
                            placeholder="请输入客户编号、客户名称、纳税人识别号、银行账号、地址、电话"
                            prefix-icon="el-icon-search"
                            v-model="likeSearch"
                            @input="forserchgroup"
                        ></el-input>
                    </div>
                    <div class="alledit-table">
                        <el-table ref="multipleTable" :data="tableData_picName" @row-click="radiochangekhClick" @row-dblclick="forsurekhDblclick" tooltip-effect="dark" style="width: 100%" height="250">
                            <el-table-column width="55" label="序号">
                                <template slot-scope="scope">
                                    <el-radio v-model="radio_Name" :label="scope.$index + 1" @change="radiochangekh(scope.row)"></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="customerNumber" label="客户编号"></el-table-column>
                            <el-table-column prop="customerName" label="客户名称"></el-table-column>
                            <el-table-column prop="taxIdentificationNumber" label="客户纳税人识别号"></el-table-column>
                            <el-table-column prop="bank" label="银行账号"></el-table-column>
                            <el-table-column prop="address" label="地址、电话"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                    <!-- 按钮 -->
                    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
                        <el-button @click="closedialogFormVisible_Name">取 消</el-button>
                        <el-button type="primary" @click="forsurekh">确 定</el-button>
                    </span>
                    <div style="height: 10px;"></div>
                </div>
            </el-dialog>

            <!-- 商品主数据弹层-项目名称 -->
            <el-dialog title="商品主数据" :visible.sync="dialogVisible_pic" width="95%" append-to-body :close-on-click-modal="false">
              <addCommoditymasterdata :dialogFormVisible="dialogFormVisible" :ruleForm="ruleForm" :title="title"
                                      @closediag="closediag" @addsuccess="addsuccess"></addCommoditymasterdata>
              <div class="area1">
                <div style="display: flex;align-items: center;justify-content: space-between;">
                    <div class="alledit" style="font-size:20px;">
                        <el-input
                            style="width:360px;padding: 2px;box-sizing: border-box;"
                            placeholder="请输入商品编号、名称、英文名称、规格型号、单价"
                            prefix-icon="el-icon-search"
                            v-model="goodslikeSearch"
                            @input="goodsforserchgroup"
                        ></el-input>
                    </div>
                  <el-button type="primary" plain @click="foraddsp()">
                    新增商品信息
                  </el-button>
                </div>
                    <div class="alledit-table">
                        <el-table ref="multipleTable" @row-click="forsurezhuClick" @row-dblclick="forsurezhuDblclick" :data="tableData_pic" tooltip-effect="dark" style="width: 100%" height="250">
                            <el-table-column width="55" label="序号">
                                <template slot-scope="scope">
                                    <el-radio
                                        v-model="radio_proName"
                                        :label="scope.$index + 1"
                                        @change="radiochangesp(scope.row)"
                                    ></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="goodsCode" label="商品编号"></el-table-column>
                            <el-table-column prop="goodsEnglishName" label="商品英文名称"></el-table-column>
                            <el-table-column prop="goodsName" label="商品名称"></el-table-column>
                            <el-table-column prop="taxCode" label="税收分类编码"></el-table-column>
                            <el-table-column prop="goodsSimpleName" label="税收分类名称"></el-table-column>
                            <el-table-column prop="spec" label="规格型号"></el-table-column>
                            <el-table-column prop="unit" label="计量单位"></el-table-column>
                            <el-table-column prop="unitPrice" label="单价"></el-table-column>
                            <el-table-column prop="taxRate" label="税率"></el-table-column>
                        </el-table>
                    </div>
                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChangePro"
                        @current-change="handleCurrentChangePro"
                        :page-sizes="[10, 20, 30, 40, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="goodstotal"
                    ></el-pagination>
                    <!-- 按钮 -->
                    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
                        <el-button @click="closedialogVisible_pic()">取 消</el-button>
                        <el-button type="primary" @click="forsurezhu">确 定</el-button>
                    </span>
                    <div style="height: 10px;"></div>
                </div>
            </el-dialog>

            <!-- 清单主数据查询 -->
            <el-dialog width="60%" :visible.sync="choose_innerVisible" append-to-body :close-on-click-modal="false">
                <div class="area1">
                    <div class="alledit" style="font-size:20px; padding:10px">
                        <div class="alledit-btn"><span style="width:100px;vertical-align: middle;">全部商品</span></div>
                        <el-input
                            style="width:360px"
                            placeholder="请输入商品编号、商品名称、规格型号、单价"
                            prefix-icon="el-icon-search"
                            v-model="chooselikeSearch"
                            @input="chooseforserchgroup"
                        ></el-input>
                    </div>

                    <div class="alledit-table">
                        <el-table ref="multipleTable" @row-dblclick='dbClickInnerVisible' :data="tableData_goods" tooltip-effect="dark" style="width: 100%" height="250">
                            <el-table-column width="55">
                                <el-table-column>
                                    <template slot-scope="scope">
                                        <el-radio
                                            v-model="radio_qdsj"
                                            :label="scope.$index + 1"
                                            @change="radiochangeqd(scope.row)"
                                        ></el-radio>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column prop="goodsCode" label="商品编号"></el-table-column>
                            <el-table-column prop="goodsName" label="商品名称"></el-table-column>
                            <el-table-column prop="spec" label="规格型号"></el-table-column>
                            <el-table-column prop="unit" label="计量单位"></el-table-column>
                            <el-table-column prop="unitPrice" label="单价"></el-table-column>
                            <el-table-column prop="taxRate" label="税率"></el-table-column>
                        </el-table>
                    </div>
                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChangeChoose"
                        @current-change="handleCurrentChangeChoose"
                        :page-sizes="[10, 20, 30, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="choosetotal"
                    ></el-pagination>
                    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
                        <el-button @click="choose_innerVisible = false">取 消</el-button>
                        <el-button type="primary" @click="forqdsure">确 定</el-button>
                    </span>
                    <div style="height: 20px;"></div>
                </div>
            </el-dialog>
            <!-- 填写清单弹层-->
            <el-dialog
                :visible.sync="innerVisible"
                append-to-body
                :close-on-click-modal="false"
                :class="title == '预览发票' ? 'demo-ruleForm noborder' : 'demo-ruleForm'"
            >
                <div class="qingdanall">
                    <img src="../../assets/img/zuo.png" />
                    <div style="padding-bottom: 50px;">
                        <div class="handle_title2">销售货物或者提供应税劳务清单</div>
                        <div class="handle_center">
                            <div>
                                <div>
                                    <span>购买方名称:</span>
                                    <span>{{ ruleFormb.customerName }}</span>
                                    <span></span>
                                </div>
                                <div style="margin-top: 9px;">
                                    <span>销售方名称:</span>
                                    <span>{{ ruleFormbxiao.name }}</span>
                                    <span></span>
                                </div>
                                <div style="margin-top: 9px;" v-if="(invoiceCode != '') & (invoiceCode != null)">
                                    所属增值税专用发票代码:{{ invoiceCode }}
                                </div>
                            </div>
                            <!-- 填写清单按钮区-->
                            <div>
                                <el-button type="primary" @click="qdfordrgain" icon="el-icon-s-operation" plain
                                           style="margin-left: 20px;margin-top: 15px;">
                                    {{qddraggable?"保存顺序":'调整顺序'}}
                                </el-button>
                                <el-button
                                    type="primary"
                                    @click="addmore_list"
                                    icon="el-icon-circle-plus-outline"
                                    :disabled="title == '预览发票' ? true : false"
                                    plain
                                >
                                    增加行
                                </el-button>
                                <el-button
                                    type="primary"
                                    @click="deletemore_list"
                                    icon="el-icon-remove-outline"
                                    :disabled="title == '预览发票' ? true : false"
                                    plain
                                >
                                    删除行
                                </el-button>
                                <el-button
                                    type="primary"
                                    @click="reducemore_list"
                                    icon="el-icon-price-tag"
                                    :disabled="title == '预览发票' ? true : false"
                                    plain
                                    >折扣行</el-button
                                >
                            </div>
                        </div>
                        <div style="border: 1px solid rgb(172, 108, 69);border-top: 0px;">
                            <div class="twobox">
                                <div class="twobox-itemhead brom">
                                    <div class="buyuser" style="width: 70px;">
                                        <el-checkbox
                                            :indeterminate="isIndeterminateqd"
                                            v-model="checkAllqd"
                                            @change="handleCheckAllChangeqd"
                                        ></el-checkbox>
                                    </div>
                                    <div>项目名称222</div>
                                    <div>规格型号</div>
                                    <div>单位</div>
                                    <div>数量</div>
                                    <div>单价</div>
                                    <div>金额</div>
                                    <div>税率</div>
                                    <div>税额</div>
                                </div>
                                <div style="max-height: 210px;overflow-y: scroll;">
                                    <el-checkbox-group v-model="checkListqd" @change="checkchangeqd">
                                        <div :draggable="qddraggable" @dragstart="handleQdDragStart($event, index)"
                                             @dragover.prevent="handleQdDragOver($event, item)"
                                             @dragenter="handleQdDragEnter($event, index)"
                                             @dragend="handleQdDragEnd($event, item)" class="twobox-itembody" v-for="(item, index) in listoflists" :key="index">
                                            <div class="buyuser" style="width: 70px;">
                                                <el-checkbox
                                                    :disabled="title == '预览发票' ? true : false"
                                                    :label="index + 1"
                                                    :key="index"
                                                ></el-checkbox>
                                            </div>
                                            <div style="display: flex;justify-content: flex-end;align-items: center;">
                                                <input
                                                    :disabled="item.type == 1 || item.type == 2 || title == '预览发票' ? true : false"
                                                    autocomplete="off"
                                                    type="text"
                                                    name="fname"
                                                    v-model="item.goodsName"
                                                />
                                                <img
                                                    @click="choosething(index, item)"
                                                    v-show="(item.type != 4) & (item.type != 1)"
                                                    style="margin-right: 5%;margin-left: 10%;cursor: pointer;"
                                                    width="15px"
                                                    height="14px"
                                                    src="../../assets/img/proname.png"
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    autocomplete="off"
                                                    type="text"
                                                    name="fname"
                                                    v-model="item.spec"
                                                    :disabled="title == '预览发票' ? true : false || emptyandnull(item.goodsName)"
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    autocomplete="off"
                                                    type="text"
                                                    name="fname"
                                                    v-model="item.unit"
                                                    :disabled="title == '预览发票' ? true : false || emptyandnull(item.goodsName)"
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    autocomplete="off"
                                                    type="number"
                                                    name="fname"
                                                    v-stopNumberMousewheel
                                                    v-model="item.quantity"
                                                    :disabled="
                                                        item.type == 1 || item.type == 2 || title == '预览发票'
                                                            ? true
                                                            : false || emptyandnull(item.goodsName)
                                                    "
                                                    @blur="changevaluequantity(item, index)"
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    autocomplete="off"
                                                    type="number"
                                                    v-stopNumberMousewheel
                                                    name="fname"
                                                    v-model="item.unitPrice"
                                                    :disabled="
                                                        item.type == 1 || item.type == 2 || title == '预览发票'
                                                            ? true
                                                            : false || emptyandnull(item.goodsName)
                                                    "
                                                    @blur="changevalueunitPrice(item, index)"
                                                    @input='chooseUnitPriceChange(item, index)'
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    autocomplete="off"
                                                    type="number"
                                                    v-stopNumberMousewheel
                                                    name="fname"
                                                    :disabled="
                                                        item.type == 1 || item.type == 2 || title == '预览发票'
                                                            ? true
                                                            : false || emptyandnull(item.goodsName)
                                                    "
                                                    :style="item.type == 1 ? 'color:red' : ''"
                                                    v-model="item.chooseMoney"
                                                    @blur="changevaluechooseMoney(item, index)"
                                                />
                                            </div>
                                            <div style="display: flex;justify-content: flex-end;align-items: center;" class="listla">
                                                <el-select
                                                    v-if="(item.OneTaxRateSign != '1') & (item.OneTaxRateSign != '2')"
                                                    @change="changevaluetaxRate(item, index)"
                                                    :class="title == '预览发票' ? 'endclass' : ''"
                                                    v-model="item.taxRate"
                                                    placeholder=" "
                                                    :disabled="
                                                        item.type == 1 || item.type == 2 || title == '预览发票'
                                                            ? true
                                                            : false || emptyandnull(item.goodsName)
                                                    "
                                                >
                                                    <el-option
                                                        v-for="item in taxRateoptions"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value"
                                                    ></el-option>
                                                </el-select>
                                                <div v-if="item.OneTaxRateSign == '1'">免税</div>
                                                <div v-if="item.OneTaxRateSign == '2'">不征收</div>
                                                <!-- <img style="margin-right: 5%;margin-left: 10%;" width="15px" height="14px" src="../../assets/img/percent.png" /> -->
                                            </div>
                                            <div>
                                                <input
                                                    :disabled="true"
                                                    autocomplete="off"
                                                    type="text"
                                                    name="fname"
                                                    v-model="item.taxRatemoney"
                                                />
                                            </div>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </div>
                        <div class="Centerhorizontally qingdanheji" style="width: 100%;">
                            <div v-if="notemptyandnull(deleteindexsqd.length)">当前已添加 {{ deleteindexsqd.length }} 条</div>
                            <div v-if="notemptyandnull(totalall.pricetotal)">金额合计 ¥ {{ totalall.pricetotal }}</div>
                            <div v-if="notemptyandnull(totalall.taxtotal)">税额合计 ¥ {{ totalall.taxtotal }}</div>
                            <div v-if="notemptyandnull(totalall.jiastotal)">价税合计 ¥ {{ totalall.jiastotal }}</div>
                        </div>
                        <!-- 填写清单底部按钮区-->
                    </div>
                    <img src="../../assets/img/you.png" />
                </div>
                <div class="handle_btn">
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-collection"
                        @click="listSave()"
                        :disabled="title == '预览发票' ? true : false"
                        >保存</el-button
                    >
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-delete"
                        @click="releselist()"
                        :disabled="title == '预览发票' ? true : false"
                        >清空票面</el-button
                    >
                </div>
            </el-dialog>
            <!-- 手工录入弹层-->
            <el-dialog
                :visible.sync="outerVisible"
                :title="numtofapiaotitle(stateall.choosetitleindex, title)"
                :close-on-click-modal="false"
                top="3%"
                :close-on-press-escape="false"
                @close="closekuang()"
            >
                <!-- 点击图片t弹层-名称 -->
                <div class="" v-if="documentStatus == '5'">
                    <div class="zuofei">
                        <div class="zuofei-text">
                            <div class="horizontally">作废</div>
                            <div>作废时间:{{ yyyyMMdd(stateall.zuofrq) }}</div>
                        </div>
                    </div>
                </div>
                <div class="Centerupdown">
                    <!-- 手工录入弹层区-->
                    <el-form ref="ruleFormb" :class="title == '预览发票' ? 'demo-ruleForm noborder' : 'demo-ruleForm'">
                        <!-- 手工录入弹层按钮区/顶部按钮-->
                        <div class="Manualinput_title">
                            <div style="display: flex;align-items: center;" class="nokuang">
                                <el-select
                                    v-model="stateall.taxpattern"
                                    :disabled="title == '预览发票' || HongChongtype == 'pu' || HongChongtype == 'zhuan' ? true : false"
                                    placeholder="请选择"
                                    style="width: 150px;margin-left: 20px;"
                                    @change="changepattern"
                                >
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <span class="isshui" v-if="!stateall.istaxincluded" v-show="title != '预览发票' ? true : false"
                                    >不含税</span
                                >
                                <span class="isshui" v-if="stateall.istaxincluded" v-show="title != '预览发票' ? true : false">含税</span>
                                <el-switch
                                    v-if="(title != '预览发票') & (HongChongtype != 'pu') & (HongChongtype != 'zhuan') ? true : false"
                                    v-model="stateall.istaxincluded"
                                    active-color="#409EFF"
                                    inactive-color="#ff4949"
                                    @change="changeincluded"
                                ></el-switch>
                            </div>
                            <!-- 顶部按钮 -->
                            <div slot="footer" class="Centerupdown">
                                <!-- 手工录入弹层按钮区-->
                                <div class="Centerupdown" v-if="title == '预览发票' ? false : true">
                                    <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-delete"
                                        @click="relese"
                                        v-if="(HongChongtype != 'pu') & (HongChongtype != 'zhuan')"
                                    >
                                        清空票面
                                    </el-button>
                                    <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-document-copy"
                                        :disabled="title == '预览发票' || stateall.taxpattern != '0'"
                                        @click="forcopy"
                                        v-if="(HongChongtype != 'pu') & (HongChongtype != 'zhuan')"
                                    >
                                        复制
                                    </el-button>
                                    <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-collection"
                                        @click="handleSave()"
                                        v-if="(HongChongtype != 'zhuan') & (HongChongtype != 'pu')"
                                    >
                                        保存
                                    </el-button>
                                    <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-mouse"
                                        @click="kaiju"
                                        v-if="
                                            notemptyandnull(
                                                buttonqx.Fillinandissuepositiveinvoice_DP_Issue ||
                                                    buttonqx.Fillinandissuepositiveinvoice_DZ_Issue ||
                                                    buttonqx.Fillinandissuepositiveinvoice_ZP_Issue ||
                                                    buttonqx.Fillinandissuepositiveinvoice_ZZ_Issue ||
                                                    kaipiaotype != 1
                                            )
                                        "
                                        >开具</el-button
                                    >
                                    <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-printer"
                                        @click="kaijubingdayin"
                                        v-if="
                                            notemptyandnull(
                                                buttonqx.Fillinandissuepositiveinvoice_DP_IssueAndPrinting ||
                                                    buttonqx.Fillinandissuepositiveinvoice_DZ_IssueAndPrinting ||
                                                    buttonqx.Fillinandissuepositiveinvoice_ZP_IssueAndPrinting ||
                                                    buttonqx.Fillinandissuepositiveinvoice_ZZ_IssueAndPrinting ||
                                                    kaipiaotype != 1
                                            )
                                        "
                                        >开具并打印</el-button
                                    >
                                </div>
                                <div class="Centerupdown" v-if="(title == '预览发票') & stateall.shenhetype">
                                    <el-button type="primary" plain icon="el-icon-collection" @click="shenhechoose()">审核通过</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="pictureall">
                            <img src="../../assets/img/zuo.png" />
                            <div class="tableall" style="min-width: 800px;">
                                <!-- 手工录入弹层头部区-->
                                <div class="price_title">
                                    <div class="price_title_item" style="font-size: 12px;visibility: hidden;">
                                        <div class="piaohead">
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">发票代码</span>
                                                <div v-if="(invoiceCode != '') & (invoiceCode != null)">{{ invoiceCode }}</div>
                                                <div v-if="invoiceCode == '' || invoiceCode == null"></div>
                                            </div>
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">发票号码</span>
                                                <div v-if="(invoiceNo != '') & (invoiceNo != null)">{{ invoiceNo }}</div>
                                                <div v-if="invoiceCode == '' || invoiceCode == null"></div>
                                            </div>
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">开票日期</span>
                                                <div v-if="(billingDate != '') & (billingDate != null)">{{ billingDate }}</div>
                                                <div v-if="invoiceCode == '' || invoiceCode == null"></div>
                                            </div>
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">校验码</span>
                                                <div v-if="(checkCode != '') & (checkCode != null)">{{ checkCode }}</div>
                                                <div v-if="invoiceCode == '' || invoiceCode == null"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="topheadit">
                                        <img class="img" src="../../assets/img/sh.png" style="padding-top: 10px;" />
                                        <div>
                                            <div style="font-size: 23px;" class="brom">
                                                {{ this.numtofapiao(stateall.choosetitleindex) }}
                                            </div>
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </div>

                                    <div class="price_title_item" style="font-size: 12px;">
                                        <div class="piaohead">
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">发票代码</span>
                                                <div v-if="(invoiceCode != '') & (invoiceCode != null)">{{ invoiceCode }}</div>
                                                <div v-else></div>
                                            </div>
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">发票号码</span>
                                                <div v-if="(invoiceNo != '') & (invoiceNo != null)">{{ invoiceNo }}</div>
                                                <div v-else></div>
                                            </div>
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">开票日期</span>
                                                <div v-if="(billingDate != '') & (billingDate != null)">
                                                    {{ formatKaipDate(billingDate) }}
                                                </div>
                                                <div v-else></div>
                                            </div>
                                            <div>
                                                <span class="brom" v-if="(invoiceCode != '') & (invoiceCode != null)">校验码</span>
                                                <div v-if="(checkCode != '') & (checkCode != null)">{{ checkCode }}</div>
                                                <div v-else></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 手工录入弹层表格区-->
                                <div class="price_table" style="border: 1px solid #AC6C45;width: 100%;">
                                    <div class="onebox box-f">
                                        <div class="buyuser brom" style="width: 3%;">
                                            <div>购</div>
                                            <div>买</div>
                                            <div>方</div>
                                        </div>
                                        <div class="detail_info">
                                            <!-- 记号记号 -->
                                            <el-form-item label="名称" label-width="110px">
                                                <div>
                                                    <el-autocomplete
                                                        class="inline-input"
                                                        v-model="ruleFormb.customerName"
                                                        :fetch-suggestions="nameall"
                                                        @select="handleSelectcustomer"
                                                    ></el-autocomplete>
                                                    <img
                                                        @click="picfnName"
                                                        v-if="
                                                            title == '预览发票' || HongChongtype == 'pu' || ruleFormb.customerNamedisable
                                                                ? false
                                                                : true
                                                        "
                                                        style="position:absolute; top:50%;right:5px;transform: translate(-50%,-50%); cursor: pointer;"
                                                        width="15px"
                                                        height="14px"
                                                        src="../../assets/img/pic.png"
                                                    />
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="纳税人识别号" label-width="110px">
                                                <el-input
                                                    v-model="ruleFormb.taxIdentificationNumber"
                                                    :disabled="
                                                        title == '预览发票' ||
                                                        HongChongtype == 'pu' ||
                                                        ruleFormb.taxIdentificationNumberdisable
                                                            ? true
                                                            : false
                                                    "
                                                    maxlength="20"
                                                    @change="nashuigz"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="地 址、电 话" label-width="110px">
                                                <el-input
                                                    v-model="ruleFormb.address"
                                                    :disabled="title == '预览发票' || ruleFormb.addressdisable ? true : false"
                                                    maxlength="100"
                                                    @input="writegz"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="开户行及账号" label-width="110px">
                                                <el-input
                                                    v-model="ruleFormb.bank"
                                                    :disabled="title == '预览发票' || ruleFormb.bankdisable ? true : false"
                                                    maxlength="100"
                                                    @input="writegz"
                                                ></el-input>
                                            </el-form-item>
                                        </div>
                                        <div class="buyuser brom" style="width: 3%;border-right:1px solid #AC6C45; ">
                                            <div>密</div>
                                            <div>码</div>
                                            <div>区</div>
                                        </div>
                                        <div class="blank mima">
                                            <div style="padding: 10px;width: 240px;">{{ stateall.miw }}</div>
                                        </div>
                                    </div>
                                    <div class="twobox">
                                        <div class="twobox-itemhead brom">
                                            <div class="buyuser" v-if="title == '预览发票' ? false : true">
                                                <el-checkbox
                                                    :indeterminate="isIndeterminate"
                                                    v-model="checkAll"
                                                    @change="handleCheckAllChange"
                                                ></el-checkbox>
                                            </div>
                                            <div>项目名称</div>
                                            <div>规格型号</div>
                                            <div>单位</div>
                                            <div>数量</div>
                                            <div>单价</div>
                                            <div>金额</div>
                                            <div>税率</div>
                                            <div>税额</div>
                                        </div>
                                        <div class="maxmxheight">
                                            <el-checkbox-group v-model="checkList" @change="checkchange">
                                                <div :draggable="draggable" @dragstart="handleDragStart($event, index)"
                                                     @dragover.prevent="handleDragOver($event, item)"
                                                     @dragenter="handleDragEnter($event, index)"
                                                     @dragend="handleDragEnd($event, item)"
                                                    class="twobox-itembody"
                                                    v-for="(item, index) in priceall"
                                                    :key="index"
                                                    v-if="!((index > 0) & (stateall.faply == '6') & (title == '编辑发票'))"
                                                >
                                                    <div class="buyuser" v-if="title == '预览发票' ? false : true">
                                                        <el-checkbox :label="index + 1" :key="index"></el-checkbox>
                                                    </div>
                                                    <div style="display: flex;justify-content: flex-end;align-items: center;">
                                                        <div v-if="item.type == 4" class="qdstyle" @click="seeqingdan">点击查看清单</div>
                                                        <input
                                                            style="text-align: start;"
                                                            v-if="item.type != 4"
                                                            autocomplete="off"
                                                            type="text"
                                                            name="fname"
                                                            v-model="item.goodsName"
                                                            :disabled="
                                                                item.type == 1 ||
                                                                item.type == 2 ||
                                                                title == '预览发票' ||
                                                                HongChongtype == 'pu' ||
                                                                HongChongtype == 'zhuan'
                                                                    ? true
                                                                    : false
                                                            "
                                                            @focus="picfn(index)"
                                                        />
                                                        <img
                                                            v-show="item.type != 4"
                                                            v-if="
                                                                item.type == 1 ||
                                                                item.type == 2 ||
                                                                title == '预览发票' ||
                                                                HongChongtype == 'pu' ||
                                                                HongChongtype == 'zhuan'
                                                                    ? false
                                                                    : true
                                                            "
                                                            @click="picfn(index)"
                                                            style="margin-right: 5%;margin-left: 10%;cursor: pointer;width: 15px;height: 14px;"
                                                            width="15px"
                                                            height="14px"
                                                            src="../../assets/img/proname.png"
                                                        />
                                                    </div>
                                                    <div :class="title != '预览发票' ? 'shuiwu' : ''">
                                                        <input
                                                            autocomplete="off"
                                                            type="text"
                                                            maxlength="40"
                                                            name="fname"
                                                            v-model="item.spec"
                                                            :disabled="
                                                                item.type == 1 ||
                                                                item.type == 2 ||
                                                                title == '预览发票' ||
                                                                HongChongtype == 'pu' ||
                                                                HongChongtype == 'zhuan'
                                                                    ? true
                                                                    : false || item.type == 4 || emptyandnull(item.goodsName)
                                                            "
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            autocomplete="off"
                                                            type="text"
                                                            name="fname"
                                                            v-model="item.unit"
                                                            :disabled="
                                                                item.type == 1 ||
                                                                item.type == 2 ||
                                                                title == '预览发票' ||
                                                                HongChongtype == 'pu' ||
                                                                HongChongtype == 'zhuan'
                                                                    ? true
                                                                    : false || item.type == 4 || emptyandnull(item.goodsName)
                                                            "
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            :style="title == '预览发票' ? 'text-align: end;' : ''"
                                                            autocomplete="off"
                                                            name="fname"
                                                            v-model="item.quantity"
                                                            :maxlength="item.maxquantity"
                                                            type="number"
                                                            v-stopNumberMousewheel
                                                            :disabled="
                                                                item.type == 1 ||
                                                                item.type == 2 ||
                                                                title == '预览发票' ||
                                                                item.type == 4 ||
                                                                HongChongtype == 'zhuan'
                                                                    ? true
                                                                    : false || stateall.faply == '6' || emptyandnull(item.goodsName)
                                                            "
                                                            @blur="changevaluequantity(item, index)"
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            :style="title == '预览发票' ? 'text-align: end; ' : ''"
                                                            autocomplete="off"
                                                            type="number"
                                                            :class="item.quantity > 0 ? '' : 'hiddenvi'"
                                                            v-stopNumberMousewheel
                                                            name="fname"
                                                            v-model="item.unitPrice"
                                                            :disabled="
                                                                stateall.taxpattern == '2' ||
                                                                item.type == 1 ||
                                                                item.type == 2 ||
                                                                title == '预览发票'
                                                                    ? true
                                                                    : false ||
                                                                      item.type == 4 ||
                                                                      HongChongtype == 'pu' ||
                                                                      HongChongtype == 'zhuan' ||
                                                                      stateall.faply == '6' ||
                                                                      emptyandnull(item.goodsName)
                                                            "
                                                            @blur="changevalueunitPrice(item, index)"
                                                            @input='chooseUnitPriceChange(item, index)'
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            autocomplete="off"
                                                            type="number"
                                                            v-stopNumberMousewheel
                                                            name="fname"
                                                            :style="item.type == 1 ? 'color:red;' : ''"
                                                            v-model="item.chooseMoney"

                                                            :disabled="
                                                                title == '预览发票'
                                                                    ? true
                                                                    : false ||
                                                                      item.type == 4 ||
                                                                      HongChongtype == 'zhuan' ||
                                                                      stateall.faply == '6' ||
                                                                      item.type == '1' ||
                                                                      emptyandnull(item.goodsName)
                                                            "

                                                            @click="forchangechae(item)"
                                                            @input='chooseMoneyChange(item, index)'
                                                            @blur="changevaluechooseMoney(item, index)"
                                                        />
                                                    </div>
                                                    <div
                                                        style="display: flex;justify-content: flex-end;align-items: center;"
                                                        class="listla"
                                                    >
                                                        <el-select
                                                            v-if="(item.OneTaxRateSign != '1') & (item.OneTaxRateSign != '2')"
                                                            @change="changevaluetaxRate(item, index)"
                                                            :class="title == '预览发票' ? 'endclass' : ''"
                                                            v-model="item.taxRate"
                                                            placeholder=" "
                                                            :disabled="
                                                                item.type == 1 || item.type == 2 || title == '预览发票'
                                                                    ? true
                                                                    : false ||
                                                                      item.type == 4 ||
                                                                      HongChongtype == 'pu' ||
                                                                      HongChongtype == 'zhuan' ||
                                                                      stateall.faply == '6' ||
                                                                      emptyandnull(item.goodsName)
                                                            "
                                                        >
                                                            <el-option
                                                                v-for="item in taxRateoptions"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item.value"
                                                            ></el-option>
                                                        </el-select>
                                                        <div v-if="item.OneTaxRateSign == '1'">免税</div>
                                                        <div v-if="item.OneTaxRateSign == '2'">不征收</div>
                                                    </div>
                                                    <div>
                                                        <input
                                                            :style="title == '预览发票' ? 'text-align: end;' : ''"
                                                            autocomplete="off"
                                                            type="text"
                                                            name="fname"
                                                            v-model="item.taxRatemoney"
                                                            :disabled="true"
                                                        />
                                                    </div>
                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                    <div class="therebox" style="width: 100%;">
                                        <div class="therebox_total brom" style="width: 100%;">
                                            <div style="width: 2.9%;"></div>
                                            <div class="total">合计</div>
                                            <div class="totalvalue">
                                                <div>金额:{{ totalall.pricetotal}}</div>
                                                <div>税额:{{ totalall.taxtotal }}</div>
                                            </div>
                                        </div>
                                        <div class="therebox_pricetotal brom" style="width: 100%;">
                                            <div style="width: 2.9%"></div>
                                            <div class="pricetotal ">价税合计(大写)</div>
                                            <div class="totalvalue">
                                                <div>{{ totalall.jiastotalda }}</div>
                                                <div>小写:{{ totalall.jiastotal }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="onebox box-f">
                                        <div class="buyuser brom" style="width: 3%;">
                                            <div>销</div>
                                            <div>售</div>
                                            <div>方</div>
                                        </div>
                                        <div class="detail_info">
                                            <el-form-item label="名称" label-width="110px">
                                                <div>
                                                    <el-input
                                                        v-model="ruleFormbxiao.name"
                                                        :disabled="true"
                                                        maxlength="100"
                                                        @input="writegz"
                                                    ></el-input>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="纳税人识别号" label-width="110px">
                                                <el-input
                                                    v-model="ruleFormbxiao.taxNumber"
                                                    :disabled="true"
                                                    maxlength="20"
                                                    @change="nashuigz"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="地 址、电 话" label-width="110px">
                                                <el-input
                                                    v-model="ruleFormbxiao.addressPhone"
                                                    :disabled="title == '预览发票' || ruleFormbxiao.addressPhonedisable ? true : false"
                                                    maxlength="100"
                                                    @change="writegz"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="开户行及账号" label-width="110px">
                                                <el-input
                                                    v-model="ruleFormbxiao.bankAccount"
                                                    :disabled="title == '预览发票' || ruleFormbxiao.bankAccountdisable ? true : false"
                                                    maxlength="100"
                                                    @change="writegz"
                                                ></el-input>
                                            </el-form-item>
                                        </div>
                                        <div class="buyuser brom" style="width: 3%;border-right:1px solid #AC6C45;">
                                            <div>备</div>
                                            <div>注</div>
                                        </div>
                                        <div class="blank" style="width: 31%;position: relative;">
                                            <div
                                                style="position: absolute;z-index: 999;right:2%;bottom: 2%;display: flex;align-items: center;"
                                            >
                                                <div :style="GetLength(bztext) > 230 ? 'color:red;font-weight: bold;' : ''">
                                                    {{ GetLength(bztext) }}
                                                </div>
                                                /
                                                <div>230</div>
                                            </div>

                                            <el-input
                                                type="textarea"
                                                :placeholder="
                                                    title == '预览发票' || HongChongtype == 'pu' || HongChongtype == 'zhuan'
                                                        ? ''
                                                        : '请输入备注'
                                                "
                                                :disabled="title == '预览发票' || HongChongtype == 'zhuan' ? beizDisable : false"
                                                v-model="bztext"
                                                :autosize="{ minRows: 4 }"
                                                maxlength="230"
                                                size="medium"
                                                style="width: 100%;height:100%;"
                                            ></el-input>
                                        </div>
                                    </div>
                                </div>
                                <!-- 手工录入弹层底部区-->
                                <div class="price_footer">
                                    <el-form-item label="收款人:" label-width="100px">
                                        <el-input
                                            v-model="ruleFormbxiao.bpayee"
                                            :disabled="title == '预览发票' || HongChongtype == 'zhuan' ? true : false"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="复核人:" label-width="110px">
                                        <el-input
                                            v-model="ruleFormbxiao.breview"
                                            :disabled="title == '预览发票' || HongChongtype == 'zhuan' ? true : false"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="开票人:" label-width="110px">
                                        <el-input
                                            v-model="ruleFormbxiao.bdrawer"
                                            :disabled="title == '预览发票' || HongChongtype == 'zhuan' ? true : false"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <img src="../../assets/img/you.png" />
                        </div>
                    </el-form>
                    <div class="Verticalcenter-inline" v-if="title != '预览发票'">
                        <div class="Verticalcenter-inline">
                            <el-button
                                type="primary"
                                @click="addmore"
                                icon="el-icon-circle-plus-outline"
                                plain
                                v-if="(HongChongtype != 'pu') & (HongChongtype != 'zhuan')"
                                style="width: 100px;margin-left: 20px;"
                                :disabled="
                                    stateall.isqingdan ||
                                        stateall.faply == '6' ||
                                        title == '预览发票' ||
                                        HongChongtype == 'pu' ||
                                        HongChongtype == 'zhuan' ||
                                        stateall.taxpattern == '2'
                                "
                            >
                                增加行
                            </el-button>
                            <el-button
                                type="primary"
                                @click="deletemore"
                                icon="el-icon-remove-outline"
                                plain
                                :disabled="stateall.faply == '6' || title == '预览发票' || stateall.taxpattern == '2'"
                                style="margin-top: 15px;margin-left: 20px;"
                            >
                                删除行
                            </el-button>
                            <el-button
                                type="primary"
                                @click="reducemore"
                                plain
                                icon="el-icon-price-tag"
                                v-if="(HongChongtype != 'pu') & (HongChongtype != 'zhuan')"
                                :disabled="
                                    stateall.isqingdan ||
                                        stateall.faply == '6' ||
                                        title == '预览发票' ||
                                        HongChongtype == 'pu' ||
                                        HongChongtype == 'zhuan' ||
                                        stateall.taxpattern != '0'
                                "
                                style="margin-top: 15px;margin-left: 20px;"
                            >
                                折扣行
                            </el-button>

                            <el-button
                                v-if="
                                    (stateall.choosetitleindex != '028') &
                                        (stateall.choosetitleindex != '026') &
                                        (HongChongtype != 'pu') &
                                        (HongChongtype != 'zhuan')
                                "
                                style="margin-top: 15px;margin-left: 20px;"
                                type="primary"
                                @click="openinnerVisible"
                                plain
                                icon="el-icon-document"
                                :disabled="
                                    (stateall.choosetitleindex == '028' || stateall.choosetitleindex == '026' ? true : false) ||
                                        title == '预览发票' || qdDisabled
                                "
                            >
                                销售清单
                            </el-button>
                            <el-button type="primary" @click="fordrgain" icon="el-icon-s-operation" plain
                                       v-if="(HongChongtype != 'pu') & (HongChongtype != 'zhuan')"
                                       style="margin-left: 20px;margin-top: 15px;" :disabled="
									stateall.isqingdan
								">

                                {{draggable?"保存顺序":'调整顺序'}}
                            </el-button>
                        </div>
                    </div>
                </div>
                <div style="height: 70px;"></div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
var rate;
export default {
    props: {
        outerVisible: {
            //开启开票弹框
            type: Boolean,
            default: false
        },
        title: {
            //开启发票的模式 预览，编辑，录入
            type: String,
            default: ''
        },
        invoiceNo: {
            //开启发票的模式 预览，编辑，录入
            type: String,
            default: ''
        },
        invoiceCode: {
            //开启发票的模式 预览，编辑，录入
            type: String,
            default: ''
        },
        billingDate: {
            //开启发票的模式 预览，编辑，录入
            type: String,
            default: ''
        },
        checkCode: {
            //开启发票的模式 预览，编辑，录入
            type: String,
            default: ''
        },
        HongChongtype: {
            type: String,
            default: '' //zhuan,pu
        },
        beizDisable: {
            type: Boolean,
            default: true
        },
        ruleFormb: {
            type: Object,
            default: function() {
                return {
                    customerName: '', //购买方名称
                    taxIdentificationNumber: '', //购买方纳税人识别号
                    address: '', //购买方地 址、电 话
                    bank: '' //购买方开户行及账号
                };
            }
        },
        priceall: {
            type: Array,
            default: function() {
                return [{}, {}, {}, {}, {}, {}, {}, {}];
            }
        },
        totalall: {
            type: Object,
            default: function() {
                return {
                    pricetotal: '',
                    jiastotal: '',
                    jiastotalda: '',
                    taxtotal: ''
                };
            }
        },
        ruleFormbxiao: {
            type: Object,
            default: function() {
                return {
                    name: '', //销售方名称
                    taxNumber: '', //销售方名称纳税人识别号
                    addressPhone: '', //销售方名称地 址、电 话
                    bankAccount: '', //销售方名称开户行及账号
                    bpayee: '', //收款人
                    breview: '', //复 核
                    bdrawer: '' //开票人
                };
            }
        },
        bztext: {
            type: String,
            default: ''
        },

        stateall: {
            type: Object,
            default: function() {
                return {
                    choosetitleindex: '',
                    istaxincluded: false,
                    isqingdan: false,
                    taxpattern: '0'
                };
            }
        },
        form_chae: {
            type: Object,
            default: function() {
                return {
                    kouchu: '',
                    chooseMoney: ''
                };
            }
        },
        listoflists: {
            type: Array,
            default: function() {
                return [{}, {}, {}, {}, {}, {}, {}, {}];
            }
        },
        iszhengshu: {
            type: Boolean,
            default: true
        },
        documentStatus: {
            type: String,
            default: '' //zhuan,pu
        },
        buttonqx: {
            type: Object,
            default: function() {
                return {};
            }
        },
        kaipiaotype: {
            type: String,
            default: '' //zhuan,pu
        }
    },

    data() {
        return {
            /* 差额征税弹框 */
            chaediag: false,
            /* 差额征税弹框 */

            /* 税率采集 */
            taxRateoptions: [],
            /* 税率采集 */

            /* 复制票面相关 */
            copydiag: false, //复制数据弹框
            tableData_copy: [], //复制发票数据源
            radio_copy: 0, //复制发票列表索引
            totalcopy: 0,
            pagecopy: 1, //第几页
            limitcopy: 10,
            chooseallcopy: '',
            likeSearchcopy: '',
            /* 复制票面相关 */

            /* 清单相关数据 */
            deleteindexsqd: '',
            checkListqd: [],
            innerVisible: false, //清单弹出
            listoflistschooseindex: '',
            isIndeterminateqd: true /* 清单全选 */,
            checkAllqd: [], //清单数据
            /* 清单相关数据 */

            /* 商品主数据相关 */
            dialogVisible_pic: false, //商品主数据弹框
            goodspage: 1, //第几页
            goodspagenum: 10, //每页条数
            pagenum: 10,
            goodssearch: {
                companyCode: '',
                goodsCode: '',
                goodsName: '',
                taxRate: '',
                unitPrice: '',
                taxCode: '',
                isEffective: '1' //是否有效 1:有效
            },
            total: '',
            chooseallsp: '',
            goodslikeSearch: '',
            tableData_pic: [],
            radio_proName: 0,
            goodstotal: '', //总条数
            // 新增商品主数据
            dialogFormVisible: false,
            ruleForm: {},
            title: {},
            /* 商品主数据相关 */

            /* 客户主数据相关 */
            dialogFormVisible_Name: false, //客户主数据弹框
            radio_Name: 0,
            likeSearch: '',
            chooseallkh: '',
            tableData_picName: [],
            tableData_picNameall: [],
            page: 1, //第几页
            limit: 10,
            search: {
                customerNumber: '', //客户编号
                customerName: '', //客户名称
                isEffective: '1', //是否有效 0:停用 1:启用
                taxIdentificationNumber: '', //纳税人识别号
                customerTaxpayerType: '', ///客户纳税人类型
                customerInvoiceType: '' //客户发票类型
            },
            /* 客户主数据相关 */

            /* 清单主数据相关 */
            choose_innerVisible: false, //清单选择商品主数据
            chooselikeSearch: '',
            choosepage: 1, //第几页
            choosepagenum: 10, //每页条数
            choosesearch: {
                companyCode: '',
                goodsCode: '',
                goodsName: '',
                taxRate: '',
                unitPrice: '',
                taxCode: '',
                isEffective: '1' //是否有效 1:有效
            },
            tableData_goods: [] /* 清单商品主数据 */,
            choosetotal: '', //总条数
            radio_qdsj: 0,
            chooseallqd: '',
            /* 清单主数据相关 */

            /*, 销方主数据相关 */
            dialogFormtoxiao: false,
            tableData_xiao: [],
            radio_xiao: 0,
            chooseallxiao: '',
            useropj: '',
            /*, 销方主数据相关 */
            faplxoption: [
                {
                    label: '电子专票',
                    value: '028'
                },
                {
                    label: '电子普票',
                    value: '026'
                },
                {
                    label: '纸质专票',
                    value: '004'
                },
                {
                    label: '纸质普票',
                    value: '007'
                }
            ],

            /* 票面明细相关 */
            priceallchooseindex: '', //票面选中索引
            isIndeterminate: true /* 全选票列表状态 */,
            checkAll: false, //是否全选
            dialogVisible_reduce: false, //折扣行弹层区
            deleteindexs: '', //删除发票多条数据
            checkList: [], //选中的List
            /* 票面明细相关 */

            /* 折扣行相关 */
            zkhang: 0 /* 点击折扣行算出的总行数 */,
            zktotal: 0 /* 点击折扣行算出的总金额 */,
            form_money: {
                DiscountRate: '', //折扣率
                DiscountMoney: '' //折扣金额
            },
            /* 折扣行相关 */

            /* 征税模式 */
            options: [
                {
                    value: '0',
                    label: '普通征税'
                },
                {
                    value: '2',
                    label: '差额征税'
                },
                {
                    value: '1',
                    label: '减按征税'
                }
            ],
            // 发票红冲的时候备份的明细
            storagpricetall: {},
            //表格拖拽
            draggable: false, //是否可拖拽
            ending: null,
            dragging: null,

            //清单拖拽
            //表格拖拽
            qddraggable: false, //是否可拖拽
            qdending: null,
            qddragging: null,

            qdDisabled:false,
        };
    },
    watch: {
        outerVisible: function(indexVal, oldVal) {
            // clearTimeout(aa)
            this.qdDisabled = false;
            this.draggable=false;
            this.qddraggable = false;
            this.useropj = JSON.parse(localStorage.getItem('useropj'));
            if (!this.listoflists) {
                this.listoflists = [{}, {}, {}, {}, {}, {}, {}, {}];
            }
            if (!this.priceall) {
                this.priceall = [{}, {}, {}, {}, {}, {}, {}, {}];
            }
            if (this.title != '手工录入') {
                while (this.priceall.length < 8) {
                    this.priceall.push({});
                }
                if (this.stateall.isqingdan) {
                    this.priceall = [{ type: 4 }];
                }
            }
            if (indexVal & (this.title == '手工录入')) {
                this.stateall.taxpattern = '0';
                this.changepattern(this.stateall.taxpattern);
                this.relese();
                this.releselist();
            }

            if (this.title == '预览发票') {
                let list = this.priceall.filter(item => item.type == 4);
                if (list.length > 0) {
                    this.qdDisabled = true;
                }
                this.priceall.forEach(item => {
                    item.taxRate = this.shuilvtotemp(item.taxRate);
                    // if(this.stateall.choosetitleindex == '026' || this.stateall.choosetitleindex == '004'){
                    if ('0%' == item.taxRate) {
                        // item.taxRatemoney = "***";
                        //0：出口退税 1：免税 2：不征税 3普通零税率
                        if (item.oneTaxRateSign == '1') {
                            item.taxRate = '免税';
                            item.taxRatemoney = '***';
                        } else if (item.oneTaxRateSign == '2') {
                            item.taxRate = '不征税';
                            item.taxRatemoney = '***';
                        } else if (item.oneTaxRateSign == '3') {
                            item.taxRate = '0%';
                            item.taxRatemoney = '***';
                        } else {
                            item.taxRate = '0%';
                            item.taxRatemoney = '***';
                        }
                    }
                    // }
                });
            }
            if (this.title != '预览发票') {
                if (indexVal) {
                    this.gettableData_picNameall();
                    this.getCurHdkpsl();
                }
                if (this.HongChongtype == 'zhuan' || this.HongChongtype == 'pu') {
                    this.priceall.forEach((item, index) => {
                        if (this.notemptyandnull(item.chooseMoney)) {
                            item.taxRatemoney = this.Amountformat(item.taxRatemoney > 0 ? item.taxRatemoney * -1 : item.taxRatemoney);
                            item.chooseMoney = this.Amountformat(item.chooseMoney > 0 ? item.chooseMoney * -1 : item.chooseMoney);
                            item.maxquantity = item.quantity;
                        }
                    });
                    this.totalall.pricetotal = this.Amountformat(
                        parseFloat(this.totalall.pricetotal) > 0 ? this.totalall.pricetotal * -1 : this.totalall.pricetotal
                    );
                    this.totalall.taxtotal = this.Amountformat(
                        parseFloat(this.totalall.taxtotal) > 0 ? this.totalall.taxtotal * -1 : this.totalall.taxtotal
                    );
                    this.totalall.jiastotal = this.Amountformat(
                        parseFloat(this.totalall.jiastotal) > 0 ? this.totalall.jiastotal * -1 : this.totalall.jiastotal
                    );
                    this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
                    if (this.notemptyandnull(this.priceall)) {
                        this.storagpricetall = JSON.parse(JSON.stringify(this.priceall));
                    }
                }
                if (this.HongChongtype == 'zhuan') {
                    if (this.notemptyandnull(this.ruleFormb.customerName)) {
                        this.ruleFormb.customerNamedisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormb.taxIdentificationNumber)) {
                        this.ruleFormb.taxIdentificationNumberdisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormb.address)) {
                        this.ruleFormb.addressdisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormb.bank)) {
                        this.ruleFormb.bankdisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.name)) {
                        this.ruleFormbxiao.namedisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.taxNumber)) {
                        this.ruleFormbxiao.taxNumberdisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.addressPhone)) {
                        this.ruleFormbxiao.addressPhonedisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.bankAccount)) {
                        this.ruleFormbxiao.bankAccountdisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.bpayee)) {
                        this.ruleFormbxiao.bpayeedisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.breview)) {
                        this.ruleFormbxiao.breviewdisable = true;
                    }
                    if (this.notemptyandnull(this.ruleFormbxiao.bdrawer)) {
                        this.ruleFormbxiao.bdrawerdisable = true;
                    }
                }
            }
            this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
        }
    },
    created() {

    },
    methods: {
        dbClickInnerVisible(row, column, event){
            this.radio_qdsj = row.index;
            this.radiochangeqd(row);
            this.forqdsure();
        },
        fordrgain() {
            this.draggable = !this.draggable
            if (this.draggable) {
                this.$message.info("请直接拖动票面明细进行调整")
            }
        },
        qdfordrgain(){
            this.qddraggable = !this.qddraggable
            if (this.qddraggable) {
                this.$message.info("请直接拖动清单明细进行调整")
            }
        },
        handleDragStart(e, index) {
            this.dragging = index;
        },
        handleDragEnd(e, item) {
            if (this.priceall[this.dragging].type == 1 || this.priceall[this.ending].type == 1) {
                this.$message.error("只能拖动和移动至非折扣行")
                return false
            }
            let newItems = JSON.parse(JSON.stringify(this.priceall))
            let obj={
                type:8,
                goodsName:"test"
            }
            var startindex=this.dragging
            var endindex=this.ending
            if (newItems[startindex].type == "2" || newItems[endindex].type == "2") {
                if (newItems[startindex].type != "2") {
                    newItems.splice(startindex,0,obj)
                    if(startindex<endindex){
                        endindex=parseFloat(endindex) +1
                    }
                }
                if (newItems[endindex].type != "2") {
                    newItems.splice(endindex,0,obj)
                    if(endindex<startindex){
                        startindex=parseFloat(startindex)+1
                    }
                }
                newItems.splice(startindex , 2, ...newItems.splice(endindex , 2, newItems[startindex ],newItems[startindex+1 ]));
            }else{
                newItems.splice(startindex , 1, ...newItems.splice(endindex , 1, newItems[startindex ]));
            }
            newItems.forEach((item,index)=>{
                if(item.type==8){
                    newItems.splice(index,1)
                }
            })
            this.dragging = null;
            this.ending = null;
            this.priceall = JSON.parse(JSON.stringify(newItems));

        },
        handleDragOver(e, item) {
            e.dataTransfer.dropEffect = "move";
        },
        handleDragEnter(e, index) {
            this.ending = index;
        },


        handleQdDragStart(e, index) {
            this.qddragging = index;
        },
        handleQdDragEnd(e, item) {
            if (this.listoflists[this.qddragging].type == 1 || this.listoflists[this.qdending].type == 1) {
                this.$message.error("只能拖动和移动至非折扣行")
                return false
            }
            let newItems = JSON.parse(JSON.stringify(this.listoflists))
            let obj={
                type:8,
                goodsName:"test"
            }
            var startindex=this.qddragging
            var endindex=this.qdending
            if (newItems[startindex].type == "2" || newItems[endindex].type == "2") {
                if (newItems[startindex].type != "2") {
                    newItems.splice(startindex,0,obj)
                    if(startindex<endindex){
                        endindex=parseFloat(endindex) +1
                    }
                }
                if (newItems[endindex].type != "2") {
                    newItems.splice(endindex,0,obj)
                    if(endindex<startindex){
                        startindex=parseFloat(startindex)+1
                    }
                }
                newItems.splice(startindex , 2, ...newItems.splice(endindex , 2, newItems[startindex ],newItems[startindex+1 ]));
            }else{
                newItems.splice(startindex , 1, ...newItems.splice(endindex , 1, newItems[startindex ]));
            }
            newItems.forEach((item,index)=>{
                if(item.type==8){
                    newItems.splice(index,1)
                }
            })
            this.qddragging = null;
            this.qdending = null;
            this.listoflists = JSON.parse(JSON.stringify(newItems));

        },
        handleQdDragOver(e, item) {
            e.dataTransfer.dropEffect = "move";
        },
        handleQdDragEnter(e, index) {
            this.qdending = index;
        },
        /*!
         * 接口调用相关
         */
        /* 	获取销售方数据 */
        getGroupCompanyList() {
            let params = '';
            if (this.emptyandnull(this.ruleFormbxiao.docId) || this.emptyandnull(this.ruleFormbxiao.version)) {
                params = {};
            } else {
                params = {
                    docId: this.ruleFormbxiao.docId,
                    version: this.ruleFormbxiao.version
                };
            }
            this.$https.fetchPost('/invoice/issueInfo/getCurRuleFormbxiao', params).then(res => {
                this.tableData_xiao = res.data.obj;
            });
        },
        // 获取所有销方主数据-不分页
        gettableData_picNameall() {
            let params = {};
            this.$https.fetchPost('/master/getAllCustomerList', params).then(res => {
                this.tableData_picNameall = res.data.data;
            });
        },
        /*  获取客户主数据列表数据*/
        getCustomerList() {
            let params = {
                search: this.search,
                likeSearch: this.likeSearch,
                page: this.page,
                limit: this.pagenum,
                sort: 'asc',
                order: 'customerNumber'
            };
            this.$https.fetchPost('/master/getInvoiceCustomerList', params).then(res => {
                console.log(res);
                for (let i=0;i<res.data.data.length;i++){
                  res.data.data[i].index=(i+1);
                }
                this.tableData_picName = res.data.data;
                this.total = res.data.count;
            });
        },
        // /*   /* 获取清单商品列表数据 */  */
        getchooseGoodsList() {
            let params = {
                page: this.choosepage,
                limit: this.choosepagenum,
                search: this.choosesearch,
                likeSearch: this.chooselikeSearch,
                sort: 'asc',
                order: 'goodsCode',
                userId: this.useropj.id
            };
            this.$https.fetchPost('/master/getInvoiceGoodsList', params).then(res => {
                console.log(res);
                for (let i=0;i<res.data.data.length;i++){
                  res.data.data[i].index=(i+1);
                }
                this.choosetotal = res.data.count;
                this.tableData_goods = res.data.data;
            });
        },
        /* 获取商品列表数据 */
        getGoodsList() {
            let params = {
                page: this.goodspage,
                limit: this.goodspagenum,
                search: this.goodssearch,
                likeSearch: this.goodslikeSearch,
                sort: 'asc',
                order: 'goodsCode',
                userId: this.useropj.id
            };
            this.$https.fetchPost('/master/getInvoiceGoodsList', params).then(res => {
                for (let i=0;i<res.data.data.length;i++){
                  res.data.data[i].index=(i+1);
                }
                this.goodstotal = res.data.count;
                this.tableData_pic = res.data.data;
            });
        },
        // 获取税率
        getCurHdkpsl() {
            let params = {
                faplx: this.stateall.choosetitleindex
            };
            this.$https.fetchPost('/invoice/issueInfo/getCurHdkpsl', params).then(res => {
                this.taxRateoptions = res.data.obj;
            });
        },
        // 获取复制发票数据
        getDocList() {
            let params = {
                likeSearch: this.likeSearchcopy,
                page: this.pagecopy,
                limit: this.limitcopy,
                sort: 'desc',
                order: 'id',
                search: {
                    faplxdm: this.stateall.choosetitleindex,
                    type: '3'
                }
            };
            this.$https.fetchPost('/invoice/issueInfo/getDocList', params).then(res => {
                this.copydiag = true;
                this.totalcopy = res.data.count;
                this.tableData_copy = res.data.data;
                this.tableData_copy.forEach(item => {
                    item.newjiastotal = this.toThousands(item.totalall.jiastotal);
                });
            });
        },
        /*!
         * 接口调用相关
         */

        /*!
         * 票面相关
         */
        // 搜索购买方数据
        handleSelectcustomer(item) {
            this.ruleFormb = item;
        },
        nameall(queryString, cb) {
            this.tableData_picNameall.forEach(item => {
                item.value = item.customerName;
            });
            var restaurants = this.tableData_picNameall;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            cb(results);
        },
        createFilter(queryString) {
            return restaurant => {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        changepattern(e) {
            this.relese();
            this.releselist();
            if (e == 0) {
                this.priceall = [{}, {}, {}, {}, {}, {}, {}, {}];
            } else if (e == 1) {
            } else if (e == 2) {
                this.priceall = [{}];
            }
        },
        /* 关闭开票弹框 */
        closekuang() {
            this.relese();
            this.releselist();
            this.$emit('closeouterVisible', false);
        },
        // 组件数据提交至页面
        handleSave(e) {
            if (this.bztext) {
                if (this.GetLength(this.bztext) > 230) {
                    this.$message.error('备注字数不能超出限制');
                    return false;
                }
            }
            if (this.priceall) {
                for (let i = 0; i < this.priceall.length; i++) {
                    if (
                        this.priceall[i].goodsName == null ||
                        this.priceall[i].goodsName == '' ||
                        JSON.stringify(this.priceall[i]) == '{}'
                    ) {
                        this.priceall.splice(i, 1);
                        i = i - 1;
                    }
                }
                this.priceall.forEach((item, index) => {
                    item.quantity = item.quantity == 0 ? '' : item.quantity;
                    item.unitPrice = item.unitPrice == 0 ? '' : item.unitPrice;
                    item.chooseMoney = item.chooseMoney == 0 ? '' : item.chooseMoney;
                    // item.taxRate = item.taxRate == 0 ? '' : item.taxRate;
                    item.taxRatemoney = item.taxRatemoney == '' ? 0 : item.taxRatemoney;
                    item.itemNo = index + 1;
                });
            }
            if (this.listoflists) {
                for (let i = 0; i < this.listoflists.length; i++) {
                    if (
                        this.listoflists[i].goodsName == null ||
                        this.listoflists[i].goodsName == '' ||
                        JSON.stringify(this.listoflists[i]) == '{}'
                    ) {
                        this.listoflists.splice(i, 1);
                        i = i - 1;
                    }
                }
                this.listoflists.forEach((item, index) => {
                    item.quantity = item.quantity == 0 ? '' : item.quantity;
                    item.unitPrice = item.unitPrice == 0 ? '' : item.unitPrice;
                    item.chooseMoney = item.chooseMoney == 0 ? '' : item.chooseMoney;
                    // item.taxRate = item.taxRate == 0 ? '' : item.taxRate;
                    item.taxRatemoney = item.taxRatemoney == '' ? 0 : item.taxRatemoney;
                    item.itemNo = index + 1;
                });
                if (!this.stateall.isqingdan) {
                    this.listoflists = [];
                }
            }
            let thing = {
                stateall: this.stateall, //所有状态
                ruleFormb: this.ruleFormb, //购买方信息
                priceall: this.priceall, //发票明细信息
                totalall: this.totalall,
                ruleFormbxiao: this.ruleFormbxiao, //销方信息
                bztext: this.bztext, //备注信息
                listoflists: this.listoflists, //清单数据
                form_chae: this.form_chae
            };
            if (this.notemptyandnull(e)) {
                thing.type = e;
            }

            this.$emit('InvoiceBackInformation', thing);
        },
        kaiju() {
            this.handleSave('kaiju');
        },
        kaijubingdayin() {
            this.handleSave('kaijubingdayin');
        },
        // 点击审核发票
        shenhechoose() {
            console.log(this.priceall);
            let state = true;
            this.priceall.forEach(item => {
                if (this.notemptyandnull(item.goodsName)) {
                    state = false;
                }
            });
            if (state) {
                this.$message.error('明细行不能为空');
                return false;
            }
            this.$emit('shenhechoose', true);
        },
        // 清空页面数据
        relese() {
            this.form_chae = {
                kouchu: '',
                chooseMoney: ''
            };
            if (this.stateall.taxpattern == '2') {
                this.priceall = [{}];
            } else {
                this.priceall = [{}, {}, {}, {}, {}, {}, {}, {}];
            }
            this.radio_qdsj = 0;
            this.radio_proName = 0;
            this.radio_Name = 0;
            Object.keys(this.totalall).map(key => (this.totalall[key] = ''));
            Object.keys(this.ruleFormb).map(key => (this.ruleFormb[key] = ''));
            (this.deleteindexs = []), (this.checkList = []), (this.bztext = '');
            this.totalall.pricetotal = '';
            this.totalall.jiastotal = '';
            this.stateall.isqingdan = false;
        },
        //获取到发票明细用户选中的索引
        checkchange(chooselist) {
            this.deleteindexs = chooselist.map(item => item - 1);
        },
        //发票全选操作
        handleCheckAllChange(val) {
            if (val) {
                let arr = [];
                this.priceall.forEach((item, index) => {
                    arr.push(index + 1);
                });
                this.checkList = arr;
                this.deleteindexs = this.checkList.map(item => item - 1);
            } else {
                this.deleteindexs = [];
                this.checkList = [];
            }
            this.isIndeterminate = false;
        },
        // 长度提示
        writegz(e) {
            if (e.value.length == 66) {
                this.$message({
                    type: 'info',
                    message: '字符超过66位可能打印时无法展示所有内容'
                });
            }
        },
        /* 纳税人识别号验证 */
        nashuigz(e) {
            if (e.length < 15) {
                this.$message({
                    type: 'info',
                    message: '纳税人识别号字数必须在15-20之间'
                });
            }
        },
        // 删除行
        deletemore() {
            if (this.deleteindexs.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择要删除的条目'
                });
                this.deleteindexs = [];
                this.checkList = [];
                return false;
            }
            var isdelete = false;
            this.deleteindexs.forEach(gtem => {
                if (this.priceall[gtem].type == '2') {
                    isdelete = true;
                }
            });
            if (isdelete) {
                this.$message({
                    type: 'error',
                    message: '存在折扣行的正数行无法删除'
                });
                return false;
            }
            this.deleteindexs.forEach(gtem => {
                if (this.priceall[gtem].type == '1') {
                    if (gtem > 0) {
                        this.priceall[gtem - 1].type = '';
                    }
                }
            });
            const newVal = this.priceall.filter((item, index) => !this.deleteindexs.includes(index));
            this.deleteindexs = [];
            this.priceall = newVal;
            this.checkList = [];
            let type = false;
            this.priceall.forEach(item => {
                if (item.type == 4) {
                    type = true;
                }
            });
            if (!type) {
                this.stateall.isqingdan = false;
            }
            if (this.priceall.length == 0) {
                this.priceall.push({});
            }
            if (this.stateall.faply == '6') {
                return false;
            }
            this.totoalamount();
        },
        // 增加行
        addmore() {
            if (this.priceall.length == 8 && this.stateall.choosetitleindex != '028' && this.stateall.choosetitleindex != '026') {
                this.$message({
                    type: 'error',
                    message: '总长度大于标准长度，不可添加行'
                });
                return false;
            }
            if (this.priceall.length == 100 && this.stateall.choosetitleindex != '004' && this.stateall.choosetitleindex != '004') {
                this.$message({
                    type: 'error',
                    message: '总长度大于标准长度，不可添加行'
                });
                return false;
            }
            this.priceall.push({});
        },
        /* 计算税额 */
        amoutTaxmoney(item, index, e) {
            if (this.notemptyandnull(item.taxRate) & this.notemptyandnull(item.chooseMoney)) {
                if (this.stateall.istaxincluded) {
                    item.taxRatemoney = item.taxRate * ((item.unitPrice * (item.quantity || 1)) / (1 + parseFloat(item.taxRate)));
                } else {
                    item.taxRatemoney = item.taxRate * item.unitPrice * (item.quantity || 1);
                }
            } else {
                item.taxRatemoney = '';
            }
            item.taxRatemoney = item.taxRatemoney == '' ? '0' : this.Amountformat(item.taxRatemoney);
        },
        /* 根据税率计算税额 */
        amountTaxmoneybytaxRate(item, index) {
            if (this.notemptyandnull(item.unitPrice) & this.emptyandnull(item.quantity)) {
                item.quantity = 1;
            }
            if ((item.chooseMoney > 0) & (item.taxRate > 0)) {
                if (this.stateall.istaxincluded) {
                    item.taxRatemoney = item.taxRate * (item.chooseMoney / (1 + parseFloat(item.taxRate)));
                } else {
                    item.taxRatemoney = item.chooseMoney * item.taxRate;
                }
            } else {
                if (this.notemptyandnull(item.chooseMoney) & (item.taxRate > 0)) {
                    if (this.stateall.istaxincluded) {
                        item.taxRatemoney = item.taxRate * (item.chooseMoney / (1 + parseFloat(item.taxRate)));
                    } else {
                        item.taxRatemoney = item.chooseMoney * item.taxRate;
                    }
                } else if (item.taxRate == 0) {
                    item.taxRatemoney = '0';
                } else {
                    item.taxRatemoney = '0';
                }
            }
            item.taxRatemoney = item.taxRatemoney == '' ? '0' : this.Amountformat(item.taxRatemoney);
        },
        /* 计算单价 */
        amountcount(item, index) {
            if (item.chooseMoney > 0) {
                item.unitPrice = item.chooseMoney / (item.quantity || 1);

            } else {
                item.unitPrice = item.chooseMoney / (item.quantity || 1);
            }

            // 2022.1.19 计算单价最大保留小数点后15位
            //外高桥 bug  【红冲】普票红冲开具时，提示单价超长 http://www.vatunion.com:8219/biz/bug-view-3477.html 从15位改为截取8为位
            let charLength = String(item.unitPrice).substring(String(item.unitPrice).lastIndexOf('.') + 1).length;
            if (charLength > 10) {
                item.unitPrice = parseFloat(item.unitPrice.toFixed(10));
            }
        },
        // 计算数量
        amountquantity(item, index) {
            if ((item.chooseMoney > 0) & (item.unitPrice > 0)) {
                item.quantity = item.chooseMoney / item.unitPrice;
            } else {
                item.quantity = '';
            }
        },
        /* 计算金额 */
        amoutchooseMoney(item, index, e) {
            if (this.notemptyandnull(item.unitPrice) & this.emptyandnull(item.quantity)) {
                item.quantity = 1;
            }
            if (this.notemptyandnull(item.unitPrice)) {
                item.chooseMoney = this.Amountformat((item.quantity || 1) * item.unitPrice);
            } else {
                item.chooseMoney = '';
            }
        },
        /* 改变数量 */
        changevaluequantity(item, index) {
            // 20210709 修改禅道1753 测试环境—发票明细只有金额时，无法进行部分红冲
            if (this.HongChongtype == 'pu' && !item.quantity && !item.unitPrice) {
                return false;
            }

            //如果红冲改变数量,数量和接收的不变则改变金额
            if (this.HongChongtype == 'pu' || this.HongChongtype == 'zhuan') {
                let state = false;
                this.storagpricetall.forEach((gtem, hxindex) => {
                    if ((index == hxindex) & (item.quantity == gtem.quantity) & this.notemptyandnull(gtem.quantity)) {
                        this.priceall[index] = JSON.parse(JSON.stringify(gtem));
                        state = true;
                    }
                });
                if (state) {
                    this.totoalamount();
                    this.$forceUpdate();
                    return false;
                }
            }
            if (this.stateall.taxpattern == '2') {
                this.amountcount(item, index);
                return false;
            }
            if (this.stateall.faply != '6') {
                //如果发票来源为扫码开票,则之前已经反算过金额税额,无需再次计算
                this.amoutchooseMoney(item, index);
                this.amoutTaxmoney(item, index);
            }
            if (!this.innerVisible & (this.stateall.faply != '6')) {
                //如果发票来源为扫码开票,则各类合计无需重新计算，价税合计不变，金额已经计算过
                this.totoalamount();
            }
            this.$forceUpdate();
        },
        /* 改变单价 */
        changevalueunitPrice(item, index) {
            if (this.stateall.taxpattern == '2') {
                return false;
            }
            if ((item.unitPrice < 0) & this.iszhengshu) {
                item.unitPrice = '';
            }
            if (this.emptyandnull(item.quantity)) {
                this.amountquantity(item, index);
            } else {
                this.amoutchooseMoney(item, index, 'price');
                this.amoutTaxmoney(item, index, 'price');
            }

            if (!this.innerVisible) {
                this.totoalamount();
            }
            this.$forceUpdate();
        },
        chooseMoneyChange(item,index){
            let arr = item.chooseMoney.split(".");
            if (arr.length == 2 && arr[1].length > 2) {
                item.chooseMoney = arr[0] + "."  + arr[1].substring(0,2);
            }
            this.$forceUpdate();
        },
      //非清单单价不能超10位
      chooseUnitPriceChange(item,index){
        let arr = item.unitPrice.split(".");
        if (arr.length == 2 && arr[1].length > 10) {
          item.unitPrice = arr[0] + "."  + arr[1].substring(0,10);
        }
        this.$forceUpdate();
      },
        /* 改变金额 */
        changevaluechooseMoney(item, index) {
            // 20210709修改纸普电普可以修改金额
            if (this.stateall.taxpattern == '2') {
                return false;
            }
            if ((item.chooseMoney < 0) & this.iszhengshu) {
                item.chooseMoney = '';
            }
          let arr = item.chooseMoney.split(".");
          if (arr.length == 1 && arr[0]!="") {
            item.chooseMoney = arr[0] + ".00";
          }
            if (this.notemptyandnull(item.unitPrice) || this.notemptyandnull(item.quantity)) {
                if ((item.unitPrice > 0) & this.emptyandnull(item.quantity)) {
                    this.amountquantity(item, index);
                } else {
                    this.amountcount(item, index);
                }
            }

            this.amountTaxmoneybytaxRate(item, index);
            if (!this.innerVisible) {
                this.totoalamount();
            }
            this.$forceUpdate();
        },
        /* 改变税率 */
        changevaluetaxRate(item, index) {
            this.amoutTaxmoney(item, index);
            if (this.notemptyandnull(item.quantity)) {
                this.amountcount(item, index);
            }
            if (!this.innerVisible) {
                this.totoalamount();
            }
            this.$forceUpdate();
        },
        //是否含税模式变更
        changeincluded() {
            if (this.stateall.taxpattern == '2') {
                this.chaepriallchange();
                return false;
            }
            if (this.stateall.isqingdan) {
                this.qingdanalltaxchange();
            } else {
                this.pricealltaxchange();
            }
            this.totoalamount();
        },
        /* 	计算合计 */
        totoalamount() {
            let total = 0;
            let shuietotal = 0;
            if (this.stateall.isqingdan) {
                for (let i = 0; i < this.listoflists.length; i++) {
                    if ((this.listoflists[i].chooseMoney != '') & (this.listoflists[i].chooseMoney != null)) {
                        total = parseFloat(this.listoflists[i].chooseMoney) + total;
                    }
                    if ((this.listoflists[i].taxRatemoney != '') & (this.listoflists[i].taxRatemoney != null)) {
                        shuietotal = parseFloat(this.listoflists[i].taxRatemoney) + shuietotal;
                    }
                }
            } else {
                for (let i = 0; i < this.priceall.length; i++) {
                    if ((this.priceall[i].chooseMoney != '') & (this.priceall[i].chooseMoney != null)) {
                        total = parseFloat(this.priceall[i].chooseMoney) + total;
                    }
                    if ((this.priceall[i].taxRatemoney != '') & (this.priceall[i].taxRatemoney != null)) {
                        shuietotal = parseFloat(this.priceall[i].taxRatemoney) + shuietotal;
                    }
                }
            }
            this.totalall.taxtotal = this.Amountformat(shuietotal);
            if (this.stateall.istaxincluded) {
                this.totalall.jiastotal = this.Amountformat(total);
                this.totalall.pricetotal = this.Amountformat(total - parseFloat(this.totalall.taxtotal));
            } else {
                this.totalall.pricetotal = this.Amountformat(total);
                this.totalall.jiastotal = this.Amountformat(total + parseFloat(this.totalall.taxtotal));
            }
            this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
        },
        chaepriallchange() {
            if (this.priceall[0].goodsName == '' || this.priceall[0].goodsName == null) {
                return false;
            }
            this.priceall.forEach((item, index) => {
                if (this.stateall.istaxincluded) {
                    item.chooseMoney = parseFloat(item.chooseMoney) + this.Amountformat(parseFloat(item.taxRatemoney));
                } else {
                    item.chooseMoney = parseFloat(item.chooseMoney) - this.Amountformat(parseFloat(item.taxRatemoney));
                }
                this.amountcount(item, index);
            });
        },
        /*!
         * 票面相关
         */

        /*!
         * 差额相关
         */
        // 差额弹出
        forchangechae(item) {
            if ((this.stateall.taxpattern == '2') & (item.goodsName != '') & (item.goodsName != null)) {
                this.chaediag = true;
            }
        },
        // 差额弹框确认
        savechae() {
            if (parseFloat(this.form_chae.kouchu) - parseFloat(this.form_chae.chooseMoney) > 0) {
                this.$message.error('扣除额不能大于含税销售额');
                return false;
            }
            this.priceall[this.priceallchooseindex].taxRatemoney = this.Amountformat(
                ((parseFloat(this.form_chae.chooseMoney) - parseFloat(this.form_chae.kouchu)) /
                    (1 + parseFloat(this.priceall[this.priceallchooseindex].taxRate))) *
                    this.priceall[this.priceallchooseindex].taxRate
            );
            this.chaediag = false;
            if (this.stateall.istaxincluded) {
                this.priceall[this.priceallchooseindex].chooseMoney = this.Amountformat(parseFloat(this.form_chae.chooseMoney));
                this.totalall.pricetotal =
                    parseFloat(this.priceall[this.priceallchooseindex].chooseMoney) -
                    parseFloat(this.priceall[this.priceallchooseindex].taxRatemoney);
            } else {
                this.priceall[this.priceallchooseindex].chooseMoney = this.Amountformat(
                    parseFloat(this.form_chae.chooseMoney) - this.priceall[this.priceallchooseindex].taxRatemoney
                );
                this.totalall.pricetotal = this.priceall[this.priceallchooseindex].chooseMoney;
            }
            this.priceall[this.priceallchooseindex].unitPrice =
                this.priceall[this.priceallchooseindex].chooseMoney / this.priceall[this.priceallchooseindex].quantity;
            this.totalall.taxtotal = this.priceall[this.priceallchooseindex].taxRatemoney;
            this.totalall.jiastotal = this.Amountformat(parseFloat(this.totalall.pricetotal) + parseFloat(this.totalall.taxtotal));
            this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
            this.bztext = '差额征税:' + this.form_chae.kouchu;
        },
        /*!
         * 差额相关
         */

        /*!
         * 销方数据相关
         */
        // 确定销方数据
        forsurexf() {
            this.ruleFormbxiao = this.chooseallxiao;
            this.dialogFormtoxiao = false;
        },
        // 销方选择数据
        radiochangexiao(val) {
            this.chooseallxiao = val;
        },
        // 销方数据弹出
        picxiaoName() {
            if (this.title == '预览发票') {
                return false;
            }
            if (this.ruleFormbxiao.name) {
                if (this.HongChongtype == 'pu' || this.HongChongtype == 'zhuan') {
                    return false;
                }
            }
            this.radio_xiao = 0;
            this.dialogFormtoxiao = true;
            this.getGroupCompanyList();
        },
        /*!
         * 销方数据相关
         */

        /*!
         * 清单数据相关
         */
        /* 打开清单 */
        openinnerVisible() {
            if (this.title == '手工录入') {
                this.releselist();
            }
            this.priceall.forEach(item => {
                if (this.notemptyandnull(item.goodsName)) {
                    this.listoflists = JSON.parse(JSON.stringify(this.priceall));
                }
            });
            this.chooseallqd = '';
            this.innerVisible = true;
        },
        /* 	清空清单 */
        releselist() {
            this.radio_qdsj = 0;
            this.radio_proName = 0;
            this.radio_Name = 0;
            this.listoflists = [{}, {}, {}, {}, {}, {}, {}, {}];
            (this.deleteindexsqd = []), (this.checkListqd = []);
        },
        /* 保存清单 */
        listSave() {
            this.priceall = [
                {
                    type: 4
                }
            ];
            this.stateall.isqingdan = true;
            this.innerVisible = false;
            this.listoflists = this.listoflists.filter(item => item.hasOwnProperty("goodsName"));
            if (this.listoflists.length > 0) {
                this.qdDisabled = true;
            }
            console.log(this.qdDisabled);
            this.totoalamount();
            console.log(this.listoflists);
        },
        /* 清单窗口弹出*/
        choosething(index, item) {
            if (this.title == '预览发票' || item.type == 1) {
                return false;
            }
            this.listoflistschooseindex = index;
            this.radio_qdsj = 0;
            this.choose_innerVisible = true;
            this.getchooseGoodsList();
        },
        /* 选择清单商品主数据 */
        chooseforserchgroup() {
            this.getchooseGoodsList();
        },
        /* 清单选择主数据 */
        radiochangeqd(val) {
            this.chooseallqd = val;
        },
        /* 清单分页*/
        handleSizeChangeChoose(val) {
            this.choosepagenum = val;
            this.getchooseGoodsList();
        },
        handleCurrentChangeChoose(val) {
            this.choosepage = val;
            this.getchooseGoodsList();
        },
        // 选择清单数据
        forqdsure() {
            /* 	this.chooseallqd.taxRate = this.chooseallqd.taxRate * 100; */
            this.listoflists[this.listoflistschooseindex] = this.chooseallqd;
            if (this.stateall.istaxincluded) {
                this.listoflists[this.listoflistschooseindex].unitPrice =
                    parseFloat(this.listoflists[this.listoflistschooseindex].unitPrice) +
                    parseFloat(this.listoflists[this.listoflistschooseindex].unitPrice) *
                        this.listoflists[this.listoflistschooseindex].taxRate;
            }
            this.changevaluequantity(this.listoflists[this.listoflistschooseindex]);
            console.log(this.listoflists);
            this.choose_innerVisible = false;
        },
        //获取到清单用户选中的索引
        checkchangeqd(chooselist) {
            this.deleteindexsqd = chooselist.map(item => item - 1);
        },
        //清单全选操作
        handleCheckAllChangeqd(val) {
            if (val) {
                let arr = [];
                this.listoflists.forEach((item, index) => {
                    arr.push(index + 1);
                });
                this.checkListqd = arr;
                this.deleteindexsqd = this.checkListqd.map(item => item - 1);
            } else {
                this.deleteindexsqd = [];
                this.checkListqd = [];
            }
            this.isIndeterminate = false;
        },
        /* 添加清单折扣行 */
        savedan() {
            if (this.emptyandnull(this.form_money.DiscountMoney)) {
                this.$message({
                    type: 'error',
                    message: '折扣金额不能为空'
                });
                return false;
            }
            var listofliststatal = 0;
            this.listoflists.forEach((item, index) => {
                console.log(item);
                if (this.notemptyandnull(item.goodsName)) {
                    if (this.deleteindexsqd.indexOf(index) != -1) {
                        listofliststatal = listofliststatal + parseFloat(item.chooseMoney);
                    }
                }
            });
            if (parseFloat(this.form_money.DiscountMoney) > listofliststatal) {
                this.$message({
                    type: 'error',
                    message: '折扣金额不能大于明细总金额'
                });
                return false;
            }
            this.deleteindexsqd.reverse();
            this.deleteindexsqd.forEach(item => {
                this.listoflists[item].type = '2';
                var newtaxratemoney;
                if (this.stateall.istaxincluded) {
                    newtaxratemoney =
                        0 -
                        ((this.listoflists[item].unitPrice / (1 + parseFloat(this.listoflists[item].taxRate))) *
                            (this.listoflists[item].quantity || 1) || this.listoflists[item].chooseMoney) *
                            this.listoflists[item].taxRate *
                            (this.form_money.DiscountRate / 100);
                } else {
                    newtaxratemoney =
                        0 -
                        (this.listoflists[item].unitPrice * (this.listoflists[item].quantity || 1) || this.listoflists[item].chooseMoney) *
                            this.listoflists[item].taxRate *
                            (this.form_money.DiscountRate / 100);
                }
                this.listoflists.splice(item + 1, 0, {
                    goodsName: this.listoflists[item].goodsName,
                    taxCode: this.listoflists[item].taxCode,
                    type: '1',
                    chooseMoney: 0 - this.Amountformat(this.listoflists[item].chooseMoney * (this.form_money.DiscountRate / 100)), //金额
                    taxRate: this.listoflists[item].taxRate, //税率
                    taxRatemoney: this.Amountformat(newtaxratemoney)
                });
            });

            this.checkListqd = [];
            this.dialogVisible_reduce = false;
            this.totoalamount();
        },
        // 增加行--清单
        addmore_list() {
            this.listoflists.push({});
        },
        // 删除行--清单
        deletemore_list(index, row) {
            if (this.deleteindexsqd.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择要删除的条目'
                });
                this.deleteindexsqd = [];
                this.checkListqd = [];
                return false;
            }
            var isdelete = false;
            this.deleteindexsqd.forEach(gtem => {
                if (this.listoflists[gtem].type == '2') {
                    isdelete = true;
                }
            });
            if (isdelete) {
                this.$message({
                    type: 'error',
                    message: '存在折扣行的正数行无法删除'
                });
                return false;
            }
            this.deleteindexsqd.forEach(gtem => {
                if (this.listoflists[gtem].type == '1') {
                    if (gtem > 0) {
                        this.listoflists[gtem - 1].type = '';
                    }
                }
            });
            const newVal = this.listoflists.filter((item, index) => !this.deleteindexsqd.includes(index));
            this.deleteindexsqd = [];
            this.listoflists = newVal;
            this.checkListqd = [];
            this.totoalamount();
        },
        // 清单折扣行
        reducemore_list() {
            if (this.deleteindexsqd.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请先选择明细行'
                });
                return false;
            }
            let arrcount = 0;
            let runall = false;
            let errorall = false;
            let shulerr = false;
            Object.keys(this.form_money).map(key => (this.form_money[key] = ''));
            this.listoflists.forEach((item, index) => {
                this.deleteindexsqd.forEach(gtem => {
                    if (index == gtem) {
                        if (item.type == 1 || item.type == 2) {
                            runall = true;
                        }
                        if (item.chooseMoney == '' || item.chooseMoney == null) {
                            errorall = true;
                        }
                        if (!(item.taxRate > 0)) {
                            shulerr = true;
                        }
                        arrcount = parseFloat(item.chooseMoney) + arrcount;
                    }
                });
            });
            if (runall) {
                this.$message({
                    type: 'info',
                    message: '选中行已含有折扣行或者选中了折扣行'
                });
                return false;
            }
            if (errorall) {
                this.$message({
                    type: 'info',
                    message: '选中行金额不能为空'
                });
                return false;
            }
            if (shulerr) {
                this.$message({
                    type: 'info',
                    message: '税率不能为空'
                });
                return false;
            }
            this.zktotal = arrcount;
            this.zkhang = this.deleteindexsqd.length;
            this.dialogVisible_reduce = true;
        },
        /* 查看清单 */
        seeqingdan() {
            this.qddraggable = false;
            this.innerVisible = true;
        },
        /*!
         * 清单数据相关
         */

        /*!
         * 商品主数据数据相关
         */
      /* 添加商品主数据 */
      foraddsp() {
        this.title = "新增商品信息";
        Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
        this.ruleForm = {
          youhzcbz: '0',
          shifyx: '1',
          shuil: '0.13',
          lingslbz: '',
          shifkj: '1',
          shifmr: '0',
        }
        this.dialogFormVisible = true;
      },
      addsuccess() {
        this.radio_proName = 0;
        this.goodslikeSearch = '';
        this.dialogFormVisible = false;
        this.getGoodsList()
      },
      closediag() {
        this.dialogFormVisible = false;
      },
        /* --商品主数据弹出*/
        picfn(index) {
            this.priceallchooseindex = index;
            this.radio_proName = 0;
            this.goodslikeSearch = '';
            this.dialogVisible_pic = true;
            this.getGoodsList();
        },
        /* 所有商品主数据列表数据搜索 */
        goodsforserchgroup() {
            this.getGoodsList();
        },
        /* 所有商品主数据列表数据的改变 */
        handleSizeChangePro(val) {
            this.goodspagenum = val;
            this.getGoodsList();
        },
        handleCurrentChangePro(val) {
            this.goodspage = val;
            this.getGoodsList();
        },
        /* 发票选择主数据 */
        radiochangesp(val) {
            this.chooseallsp = val;
        },
        /* 关闭商品主数据弹框 */
        closedialogVisible_pic() {
            this.dialogVisible_pic = false;
        },
        /* 	确认选择商品主数据 */
        forsurezhu() {
            if (this.stateall.faply == '6') {
                let count = 0;
                this.priceall.forEach((item, index) => {
                    if (this.notemptyandnull(item.goodsName) & (this.priceallchooseindex != index)) {
                        count++;
                    }
                });
                if (count > 0) {
                    this.$message({
                        type: 'error',
                        message: '扫码开票仅允许存在一条明细行'
                    });
                    return false;
                }
            }
            if (this.stateall.taxpattern == '1') {
                if (this.chooseallsp.taxIncentivePolicyDescription != '4') {
                    this.$message({
                        type: 'error',
                        message: '只有优惠政策为“按5%简易征收减按1.5%计征”的才能选择减按征税'
                    });
                    return false;
                }
            }
            /* 判断当前是否含税后插入 */
            if (this.stateall.istaxincluded || this.stateall.taxpattern == '2') {
                this.chooseallsp.unitPrice = (parseFloat(this.chooseallsp.taxRate) + 1) * this.chooseallsp.unitPrice;
                if (this.chooseallsp.unitPrice == 0) {
                    this.chooseallsp.unitPrice = '';
                }
            }
            if (this.stateall.taxpattern == '2') {
                this.form_chae.chooseMoney = this.chooseallsp.unitPrice;
                this.chooseallsp.quantity = 1;
                this.chooseallsp.unitPrice = '';
                this.chaediag = true;
                this.priceall[this.priceallchooseindex] = this.chooseallsp;
            } else {
                // 如果是扫码开票,价税合计不变,根据税率反算税额,且数量为1
                if (this.stateall.faply == '6') {
                    var otherprice = 0;
                    this.chooseallsp.quantity = 1;
                    this.chooseallsp.unitPrice = parseFloat(this.totalall.jiastotal) / (1 + parseFloat(this.chooseallsp.taxRate));
                    this.chooseallsp.chooseMoney = this.Amountformat(this.chooseallsp.unitPrice * this.chooseallsp.quantity);
                    this.chooseallsp.taxRatemoney = this.Amountformat(parseFloat(this.totalall.jiastotal) - this.chooseallsp.chooseMoney);
                    this.totalall.pricetotal = this.chooseallsp.chooseMoney;
                    this.totalall.taxtotal = this.chooseallsp.taxRatemoney;
                }
                // 普通开票方式
                this.priceall[this.priceallchooseindex] = this.chooseallsp;
                if (this.chooseallsp.taxRate == 0.0) {
                    this.chooseallsp.taxRate = '0';
                }
                this.changevaluequantity(this.priceall[this.priceallchooseindex]);
            }
            this.dialogVisible_pic = false;
        },

      /* 	确认选择商品主数据 */
      forsurezhuDblclick(row, column, event) {
        this.chooseallsp = row;
        if (this.stateall.faply == '6') {
          let count = 0;
          this.priceall.forEach((item, index) => {
            if (this.notemptyandnull(item.goodsName) & (this.priceallchooseindex != index)) {
              count++;
            }
          });
          if (count > 0) {
            this.$message({
              type: 'error',
              message: '扫码开票仅允许存在一条明细行'
            });
            return false;
          }
        }
        if (this.stateall.taxpattern == '1') {
          if (this.chooseallsp.taxIncentivePolicyDescription != '4') {
            this.$message({
              type: 'error',
              message: '只有优惠政策为“按5%简易征收减按1.5%计征”的才能选择减按征税'
            });
            return false;
          }
        }
        /* 判断当前是否含税后插入 */
        if (this.stateall.istaxincluded || this.stateall.taxpattern == '2') {
          this.chooseallsp.unitPrice = (parseFloat(this.chooseallsp.taxRate) + 1) * this.chooseallsp.unitPrice;
          if (this.chooseallsp.unitPrice == 0) {
            this.chooseallsp.unitPrice = '';
          }
        }
        if (this.stateall.taxpattern == '2') {
          this.form_chae.chooseMoney = this.chooseallsp.unitPrice;
          this.chooseallsp.quantity = 1;
          this.chooseallsp.unitPrice = '';
          this.chaediag = true;
          this.priceall[this.priceallchooseindex] = this.chooseallsp;
        } else {
          // 如果是扫码开票,价税合计不变,根据税率反算税额,且数量为1
          if (this.stateall.faply == '6') {
            var otherprice = 0;
            this.chooseallsp.quantity = 1;
            this.chooseallsp.unitPrice = parseFloat(this.totalall.jiastotal) / (1 + parseFloat(this.chooseallsp.taxRate));
            this.chooseallsp.chooseMoney = this.Amountformat(this.chooseallsp.unitPrice * this.chooseallsp.quantity);
            this.chooseallsp.taxRatemoney = this.Amountformat(parseFloat(this.totalall.jiastotal) - this.chooseallsp.chooseMoney);
            this.totalall.pricetotal = this.chooseallsp.chooseMoney;
            this.totalall.taxtotal = this.chooseallsp.taxRatemoney;
          }
          // 普通开票方式
          this.priceall[this.priceallchooseindex] = this.chooseallsp;
          if (this.chooseallsp.taxRate == 0.0) {
            this.chooseallsp.taxRate = '0';
          }
          this.changevaluequantity(this.priceall[this.priceallchooseindex]);
        }
        this.dialogVisible_pic = false;
      },
      forsurezhuClick(row, column, event) {
        this.radio_proName = row.index;
        this.chooseallsp = row;
      },
        /*!
         * 商品主数据数据相关
         */

        /*!
         * 客户主数据数据相关
         */
        /*客户主数据弹出*/
        picfnName() {
            if (this.title == '预览发票') {
                return false;
            }
            if (this.ruleFormb.customerNamedisable) {
                return false;
            }
            this.radio_Name = 0;
            this.likeSearch = '';
            this.dialogFormVisible_Name = true;
            this.getCustomerList();
        },
        /* 客户主数据分页 */
        handleSizeChange(val) {
            this.pagenum = val;
            this.getCustomerList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getCustomerList();
        },
        /* 关闭客户主数据弹框 */
        closedialogFormVisible_Name() {
            this.dialogFormVisible_Name = false;
        },
        /* 客户主数据列表数据搜索 */
        forserchgroup() {
            this.getCustomerList();
        },
        /* 客户主数据选择 */
        forsurekh() {
            this.ruleFormb = this.chooseallkh;
            this.dialogFormVisible_Name = false;
        },
        forsurekhDblclick(row, column, event) {
          this.ruleFormb = row;
          this.dialogFormVisible_Name = false;
        },
        /* 发票选择客户主数据 */
        radiochangekh(val) {
            this.chooseallkh = val;
        },
      /* 发票选择客户主数据 */
      radiochangekhClick(row, column, event) {
        this.radio_Name = row.index;
        this.chooseallkh = row;
      },
        /*!
         * 客户主数据数据相关
         */

        /*!
         * 复制发票相关
         */
        // 复制发票搜索
        forserchcopy() {
            this.getDocList();
        },
        // 复制票面弹出
        forcopy() {
            this.radio_copy = 0;
            this.likeSearchcopy = '';
            this.chooseallcopy = [];
            this.getDocList();
        },
        // 选择复制发票数据
        radiochangecopy(val) {
            this.chooseallcopy = val;

            console.log(this.chooseallcopy);
        },
        /* 复制发票分页 */
        handleSizeChangecopy(val) {
            this.limitcopy = val;
            this.getDocList();
        },
        handleCurrentChangecopy(val) {
            this.pagecopy = val;
            this.getDocList();
        },
        // 确定复制票面
        forsurecopy() {
            if (this.emptyandnull(this.chooseallcopy)) {
                this.$message.error('选中数据不能为空');
                return false;
            }
            this.ruleFormb = this.chooseallcopy.ruleFormb;
            //  BUG 2272:2022.1.20 ，复制已开发票会携带大类，开具时会自动拼接大类，导入大类重复
            console.log(JSON.stringify(this.chooseallcopy));
            if(this.chooseallcopy.priceall){
              for (let index = 0; index < this.chooseallcopy.priceall.length; index++) {
                let goodName = this.chooseallcopy.priceall[index].goodsName;
                this.chooseallcopy.priceall[index].goodsName = goodName.substring(goodName.lastIndexOf('*') + 1);
              }
            }else if(this.chooseallcopy.listoflists){
              for (let index = 0; index < this.chooseallcopy.listoflists.length; index++) {
                let goodName = this.chooseallcopy.listoflists[index].goodsName;
                this.chooseallcopy.listoflists[index].goodsName = goodName.substring(goodName.lastIndexOf('*') + 1);
              }
              if (this.listoflists.length > 0) {
                this.qdDisabled = true;
              }
              this.stateall.isqingdan = true;
              this.chooseallcopy.priceall=[];
            }

            this.priceall = this.chooseallcopy.priceall;
            this.totalall = this.chooseallcopy.totalall;
            this.ruleFormbxiao = this.chooseallcopy.ruleFormbxiao;
            this.form_chae = this.chooseallcopy.form_chae;
            this.bztext = this.chooseallcopy.bztext;
            this.stateall = this.chooseallcopy.stateall;
            this.listoflists = this.chooseallcopy.listoflists;
            this.invoiceNo = '';
            this.invoiceCode = '';
            this.billingDate = '';
            this.checkCode = '';
            this.ruleFormbxiao.version = null;

            while (this.priceall.length < 8) {
                this.priceall.push({});
            }
            if (this.stateall.isqingdan) {
                this.priceall = [{ type: 4 }];
            }
            this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
            this.copydiag = false;
        },
        /*!
         * 复制发票相关
         */

        /*!
         * 折扣金额相关
         */
        /* 改变折扣金额 */
        changemoney(e) {
            this.form_money.DiscountMoney = this.Amountformat((e / 100) * this.zktotal);
        },
        /* 改变折扣行 */
        changelv(e) {
            this.form_money.DiscountRate = (e / this.zktotal) * 100;
        },
        // 折扣行保存
        forsave() {
            if (this.innerVisible) {
                this.savedan();
                return false;
            }
            if (this.emptyandnull(this.form_money.DiscountMoney)) {
                this.$message({
                    type: 'error',
                    message: '折扣金额不能为空'
                });
                return false;
            }
            var pricetatal = 0;
            var newpriceall = [];
            this.priceall.forEach((item, index) => {
                if (this.notemptyandnull(item.goodsName)) {
                    newpriceall.push(item);
                    if (this.deleteindexs.indexOf(index) != -1) {
                        pricetatal = pricetatal + parseFloat(item.chooseMoney);
                    }
                }
            });
            if (parseFloat(this.form_money.DiscountMoney) > pricetatal) {
                this.$message({
                    type: 'error',
                    message: '折扣金额不能大于明细总金额'
                });
                return false;
            }
            if (
                parseFloat(this.deleteindexs.length) + parseFloat(newpriceall.length) > 8 &&
                this.stateall.choosetitleindex != '028' &&
                this.stateall.choosetitleindex != '026'
            ) {
                this.$message({
                    type: 'error',
                    message: '折扣总长度大于标准长度，不可添加折扣行'
                });
                return false;
            }
            if (
                parseFloat(this.deleteindexs.length) + parseFloat(newpriceall.length) > 100 &&
                this.stateall.choosetitleindex != '004' &&
                this.stateall.choosetitleindex != '004'
            ) {
                this.$message({
                    type: 'error',
                    message: '折扣总长度大于标准长度，不可添加折扣行'
                });
                return false;
            }
            this.deleteindexs.reverse();
            this.deleteindexs.forEach(item => {
                this.priceall[item].type = '2';
                var newtaxratemoney;
                if (this.stateall.istaxincluded) {
                    newtaxratemoney =
                        0 -
                        ((this.priceall[item].unitPrice / (1 + parseFloat(this.priceall[item].taxRate))) *
                            (this.priceall[item].quantity || 1) || this.priceall[item].chooseMoney) *
                            this.priceall[item].taxRate *
                            (this.form_money.DiscountRate / 100);
                } else {
                    newtaxratemoney =
                        0 -
                        (this.priceall[item].unitPrice * (this.priceall[item].quantity || 1) || this.priceall[item].chooseMoney) *
                            this.priceall[item].taxRate *
                            (this.form_money.DiscountRate / 100);
                }
                this.priceall.splice(item + 1, 0, {
                    taxCode: this.priceall[item].taxCode,
                    goodsName: this.priceall[item].goodsName,
                    type: '1',
                    chooseMoney: 0 - this.Amountformat(this.priceall[item].chooseMoney * (this.form_money.DiscountRate / 100)), //金额
                    taxRate: this.priceall[item].taxRate, //税率
                    taxRatemoney: this.Amountformat(newtaxratemoney) //税额
                });
            });

            for (let i = 0; i < this.priceall.length; i++) {
                if (this.emptyandnull(this.priceall[i].goodsName) & (this.deleteindexs.length > 0)) {
                    this.priceall.splice(i, 1);
                    this.deleteindexs.pop();
                }
            }
            this.totoalamount();
            this.dialogVisible_reduce = false;
        },
        // 折扣行
        reducemore() {
            if (this.deleteindexs.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请先选择明细行'
                });
                return false;
            }
            let arrcount = 0;
            let runall = false;
            let errorall = false;
            let shulerr = false;
            Object.keys(this.form_money).map(key => (this.form_money[key] = ''));
            this.priceall.forEach((item, index) => {
                this.deleteindexs.forEach(gtem => {
                    if (index == gtem) {
                        if (item.type == 1 || item.type == 2) {
                            runall = true;
                        }
                        if (item.chooseMoney == '' || item.chooseMoney == null) {
                            errorall = true;
                        }
                        if (!(item.taxRate > 0)) {
                            shulerr = true;
                        }
                        arrcount = parseFloat(item.chooseMoney) + arrcount;
                    }
                });
            });
            if (runall) {
                this.$message({
                    type: 'info',
                    message: '选中行已含有折扣行或者选中了折扣行'
                });
                return false;
            }
            if (errorall) {
                this.$message({
                    type: 'info',
                    message: '选中行金额不能为空'
                });
                return false;
            }
            if (shulerr) {
                this.$message({
                    type: 'info',
                    message: '税率不能为空'
                });
                return false;
            }
            this.zktotal = arrcount;
            this.zkhang = this.deleteindexs.length;
            this.dialogVisible_reduce = true;
        },
        qingdanalltaxchange() {
            this.listoflists.forEach((item, index) => {
                if ((item.type != 1) & (item.type != 4) & (item.chooseMoney > 0)) {
                    if (this.stateall.istaxincluded) {
                        item.chooseMoney = parseFloat(item.chooseMoney) + parseFloat(item.taxRatemoney);
                    } else {
                        item.chooseMoney = item.chooseMoney - item.taxRatemoney;
                    }
                    item.chooseMoney = this.Amountformat(item.chooseMoney);
                    if (this.notemptyandnull(item.unitPrice)) {
                        this.amountcount(item, index);
                    }
                    // this.amoutchooseMoney(item, index);
                }
            });
            /* 	根据状态变更计算折扣行 */
            this.listoflists.forEach((item, index) => {
                if (item.type == 1) {
                    if (this.stateall.istaxincluded) {
                        item.chooseMoney =
                            (item.chooseMoney /
                                (parseFloat(this.listoflists[index - 1].chooseMoney) -
                                    parseFloat(this.listoflists[index - 1].taxRatemoney))) *
                            this.listoflists[index - 1].chooseMoney;
                    } else {
                        item.chooseMoney =
                            (item.chooseMoney /
                                (parseFloat(this.listoflists[index - 1].chooseMoney) +
                                    parseFloat(this.listoflists[index - 1].taxRatemoney))) *
                            this.listoflists[index - 1].chooseMoney;
                    }
                    item.chooseMoney = this.Amountformat(item.chooseMoney);
                }
            });
        },
        pricealltaxchange() {
            this.priceall.forEach((item, index) => {
                if ((item.type != 1) & (item.type != 4) & (item.chooseMoney > 0)) {
                    if (this.stateall.istaxincluded) {
                        item.chooseMoney = parseFloat(item.chooseMoney) + parseFloat(item.taxRatemoney);
                        if (this.notemptyandnull(item.unitPrice)) {
                            item.unitPrice = item.chooseMoney / item.quantity;
                        }
                    } else {
                        if (this.notemptyandnull(item.unitPrice)) {
                            item.unitPrice = item.chooseMoney / (1 + parseFloat(item.taxRate)) / item.quantity;
                        }
                        item.chooseMoney = item.chooseMoney - item.taxRatemoney;
                    }
                    item.chooseMoney = this.Amountformat(item.chooseMoney);

                    // this.amoutchooseMoney(item, index);
                }
            });
            /* 	根据状态变更计算折扣行 */
            this.priceall.forEach((item, index) => {
                if (item.type == 1) {
                    if (this.stateall.istaxincluded) {
                        item.chooseMoney =
                            (item.chooseMoney /
                                (parseFloat(this.priceall[index - 1].chooseMoney) - parseFloat(this.priceall[index - 1].taxRatemoney))) *
                            this.priceall[index - 1].chooseMoney;
                    } else {
                        item.chooseMoney =
                            (item.chooseMoney /
                                (parseFloat(this.priceall[index - 1].chooseMoney) + parseFloat(this.priceall[index - 1].taxRatemoney))) *
                            this.priceall[index - 1].chooseMoney;
                    }
                    item.chooseMoney = this.Amountformat(item.chooseMoney);
                }
            });
        }
        /*!
         * 折扣金额相关
         */
    }
};
</script>

<style scoped lang="less">
.hiddenvi {
    // visibility: hidden;
}
.area1 {
    margin-left: 20px;
    margin-right: 20px;
}
.zuofei-text {
    transform: rotate(10deg);
    -ms-transform: rotate(10deg); /* IE 9 */
    -webkit-transform: rotate(10deg); /* Safari and Chrome */
}
.zuofei-text > div:nth-of-type(1) {
    color: red;
    font-size: 30px;
}
.zuofei-text > div:nth-of-type(2) {
    font-size: 14px;
    color: red;
}
.zuofei:extend(.Verticalcenter) {
    z-index: 999;
    width: 233.4px;
    height: 113.4px;
    background-image: url(../../assets/img/zuofeihong.jpg);
    background-size: 100%;
    position: absolute;
    margin-left: 20px;
    margin-top: 50px;
}
.mima {
    width: 33%;
    font-size: 16px;
}
.piaohead > div:extend(.Centerupdown) {
}
.piaohead > div > div {
    color: #606266;
}
.piaohead > div > div:last-child {
    width: 140px;
}

/deep/.el-table--small td {
    padding: 4px 0;
}
.qingdanall:extend(.Centerupdown) {
    box-shadow: 9px 9px 9px 9px rgba(0, 0, 0, 0.16);
    margin-top: 10px;
    margin-bottom: 10px;
}
.pictureall:extend(.Centerupdown) {
    width: 100%;
    box-shadow: -9px 9px 9px 9px rgba(0, 0, 0, 0.16);
    margin-top: 10px;
    padding-bottom: 20px;
}

/deep/.el-textarea__inner {
    border: 0px;
}

/* 弹层 */
/deep/ .el-dialog__body {
    padding-bottom: 0;
}

.price_footer:extend(.between-space) {
    margin-top: 3px;
}

@media screen and (max-width: 1450px) {
    .demo-ruleForm /deep/ .el-input__inner {
        border: 1px solid #ac6c45;
        height: 18px;
    }
    /deep/.el-dialog {
        width: 97%;
    }
    .maxmxheight {
        max-height: 70px;
        overflow: scroll;
    }
    .demo-ruleForm /deep/.el-form-item {
        margin: -5px;
    }
    .nokuang/deep/.el-input__inner {
        height: 30px;
    }
    .demo-ruleForm /deep/.el-form-item__label {
        color: #a9673f;
    }

    .pictureall > img {
        height: 400px;
        margin-right: 15px;
        margin-left: 15px;
    }
    .qingdanall > img {
        height: 200px;
    }
    /* 弹层 */
    /deep/ .el-dialog__body {
        font-size: 12px;
        padding: 0px 20px;
    }
    /deep/.el-dialog__wrapper {
        top: -33px;
    }
    /deep/.el-dialog__header {
        padding: 5px 9px 7px;
    }
    /deep/ .el-dialog__headerbtn {
        top: 10px;
    }
    .price_title:extend(.between-line) {
        width: 100%;
    }
    .price_title_item > div > div {
        margin-top: 5px;
    }

    .twobox-itembody {
        display: flex;
        height: 20px;
        width: 100%;
        border-bottom: 1px solid #ac6c45;
    }
    .price_footer:extend(.between-space) {
        margin-top: 3px;
    }
}
@media screen and (min-width: 1450px) {
    .price_footer:extend(.between-space) {
        margin-top: 23px;
    }
    .maxmxheight {
        max-height: 80px;
        overflow: scroll;
    }
    .pictureall > img {
        height: 600px;
        margin-right: 15px;
        margin-left: 15px;
    }
    /deep/.el-dialog {
        width: 88%;
    }
    .qingdanall > img {
        height: 400px;
    }
    .price_title_item > div > div {
        margin-top: 10px;
    }
    .twobox-itembody {
        display: flex;
        height: 30px;
        width: 100%;
        border-bottom: 1px solid #ac6c45;
    }

    /deep/.el-form-item {
        margin: 0;
    }
    .demo-ruleForm /deep/ .el-input__inner {
        border: 1px solid #ac6c45;
        height: 26px;
    }
    .nokuang/deep/.el-input__inner {
        height: 30px;
    }
    .demo-ruleForm /deep/.el-form-item__label {
        color: #a9673f;
    }
}
@media screen and (min-width: 1700px) {
    /deep/.el-dialog {
        width: 80%;
    }
    .maxmxheight {
        max-height: 250px;
        overflow: scroll;
    }
}
@media screen and (min-width: 1921px) {
    /deep/.el-dialog {
        width: 68%;
    }
}

@media screen and (max-width: 1290px) {
    .maxmxheight {
        max-height: 110px;
        overflow: scroll;
    }
}
@media screen and (max-width: 1200px) {
    .maxmxheight {
        max-height: 250px;
        overflow: scroll;
    }
}
@media screen and (max-width: 1450px) and (min-width: 1370px) {
    .maxmxheight {
        max-height: 250px;
        overflow: scroll;
    }
}

.qdstyle:extend(.Centerhorizontally) {
    width: 100%;
    color: #2f66fc;
    cursor: pointer;
    font-size: 16px;
    text-decoration: underline;
}
.totalvalue:extend(.between-line) {
    width: 75%;
}
.totalvalue > div {
    margin-left: 5px;
    margin-right: 5px;
}
.alledit-btn:extend(.Centerupdown) {
}

.pagination {
    margin-top: 15px;
}

.isshui {
    font-size: 12px;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    margin-left: 16px;
    margin-right: 10px;
}

.title {
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #cccccc;
    color: #409eff;
    font-size: 22px;
}

.btn_search:extend(.between-space) {
    padding: 10px;
    box-sizing: border-box;
}

/deep/ .el-table th {
    text-align: center;
}

/deep/ .el-table td {
    text-align: center;
}

.topheadit:extend(.Verticalcenter-line) {
    width: 100%;
    height: 136px;
}

.topheadit > div:extend(.Verticalcenter-line) {
    margin-top: -118px;
}

.price_title:extend(.end-flex) {
}

.price_title_item {
    /* text-align: center; */
}

.price_title_item > div > div > span {
    width: 70px;
    margin-right: 10px;
    text-align-last: justify;
}

.price {
    text-align: center;
}

.line {
    width: 303px;
    height: 0;
    border-bottom: 1px solid #ac6c45;
    margin-top: 8px;
}

.box-f {
    display: flex;
    width: 100%;
}

.twobox {
    width: 100%;
    border-top: 1px solid #ac6c45;
}

.even {
    border-left: 1px solid #ac6c45;
    border-right: 1px solid #ac6c45;
}

.therebox {
    border-bottom: 1px solid #ac6c45;
}

.therebox_total {
    display: flex;
    border-top: 1px solid #ac6c45;
    border-bottom: 1px solid #ac6c45;
}

.therebox_pricetotal {
    display: flex;
}
.total {
    width: 22%;
    text-align: center;
    border-right: 1px solid #ac6c45;
    padding-top: 7px;
    padding-bottom: 7px;
}
.pricetotal {
    width: 22%;
    text-align: center;
    border-right: 1px solid #ac6c45;
    padding-top: 7px;
    padding-bottom: 7px;
}

.detail_info:extend(.Verticalcenter-inline) {
    width: 58%;
    border-left: 1px solid #ac6c45;
    border-right: 1px solid #ac6c45;
    padding: 3px 25px;
    box-sizing: border-box;
}

.twobox-itemhead {
    display: flex;
    height: 30px;
    width: 100%;
}

.twobox-itemhead > div:extend(.Centerhorizontally) {
    border-right: 1px solid #ac6c45;
    width: 10%;
    border-bottom: 1px solid #ac6c45;
}

.twobox-itemhead > div:nth-of-type(1) {
    width: 3%;
}

.twobox-itemhead > div:nth-of-type(2) {
    width: 22%;
}

.twobox-itemhead > div:nth-of-type(3) {
    width: 15%;
}

.twobox-itemhead > div:nth-of-type(9) {
    border-right: 0px solid #ac6c45;
}

.twobox-itembody > div:last-child {
    border-bottom: 0px;
}

.twobox-itembody > div {
    border-right: 1px solid #ac6c45;
    width: 10%;
}

.twobox-itembody > div:nth-of-type(1) {
    width: 3%;
}

.twobox-itembody > div > input {
    width: 100%;
    border: none;
    height: 100%;
    text-align: center;
}

.twobox-itembody > div:nth-of-type(2) {
    width: 22%;
}

.twobox-itembody > div:nth-of-type(3) {
    width: 15%;
}

.twobox-itembody > div:nth-of-type(9) {
    border-right: 0px solid #ac6c45;
}

.twobox-itembody:last-child {
    border-bottom: 0px;
}

.buyuser:extend(.Verticalcenter) {
    width: 3%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
}

.innerline {
    border-top: 1px solid #ac6c45;
    border-bottom: 1px solid #ac6c45;
}

.twobox-item {
    padding: 13px 40px;
}

.form-item {
    display: flex;
    margin-top: 20px;
}

.btn_g {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: right;
}

.Manualinput_title:extend(.between-space) {
}

/* 手工录入 */
.hand_title1 {
    padding: 15px;
    color: #409eff;
    font-size: 27px;
    box-sizing: border-box;
    border-bottom: 1px solid #cccccc;
}

.handle_title2 {
    text-align: center;
    box-sizing: border-box;
    margin-bottom: 30px;
    color: #ac6c45;
    font-size: 17px;
}

.handle_center:extend(.between-space) {
    letter-spacing: 1px;
    font-size: 14px;
    color: #ac6c45;
    margin-bottom: 15px;
}
/deep/.el-checkbox__label {
    display: none;
}
/deep/ .handle_btn {
    margin-top: 10px;
    padding-bottom: 20px;
    text-align: center;
}

/deep/.form-item {
    margin-top: 10px;
}

::-webkit-scrollbar {
    display: none;
}
.maxmxheight {
    -ms-overflow-style: none;
}
/* /deep/.el-textarea{
		width: 10%;
	} */
/* 清单弹层--input */
.inputmodel_list {
    width: 150px;
    border: none;
    border-bottom: 1px solid #cccccc;
    text-align: center;
}

/* 点击图片弹层--项目名称 */

.alledit :extend(.between-space) {
    display: flex;
    margin-bottom: 20px;
}

.el-pagination {
    text-align: center;
    margin-top: 20px;
}

/* 点击图片弹层--项目名称--查看商品 */
.demo-ruleForm-item:extend(.around-space) {
}
.detail_info /deep/.el-form-item__label {
    text-align-last: justify;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
    background-color: white;
    color: black;
    cursor: not-allowed;
}
/deep/.el-input.is-disabled .el-input__inner {
    background-color: white;
    color: black;
    cursor: not-allowed;
}
.noborder /deep/ .el-input__inner {
    border: 0px;
}
.noborder /deep/.el-icon-arrow-up:before {
    display: none;
}
.noborder .twobox-itembody {
    border-bottom: 0px;
}
input:disabled {
    background-color: white;
}
.noborder .twobox-itemhead > div:nth-of-type(1) {
    width: 25%+1.7px;
}
.noborder .twobox-itemhead > div:nth-of-type(2) {
    width: 15%;
}
.noborder .twobox-itemhead > div:last-child {
    border-right: 0px;
}
.noborder .twobox-itembody > div:nth-of-type(1) {
    width: 25%+1.7px;
}
.noborder .twobox-itembody > div:nth-of-type(2) {
    width: 15%;
}
.noborder .twobox-itembody > div:last-child {
    border-right: 0px;
}
.listla/deep/.el-input--small .el-input__icon {
    line-height: 17px;
    display: none;
}
.listla/deep/.el-input__inner {
    border: none;
    text-align: center;
    padding-right: 10px;
}
.endclass/deep/.el-input__inner {
    border: none;
    text-align: right;
    padding-right: 0px;
}
/deep/.el-autocomplete {
    display: block;
}
input:focus {
    outline: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type='number'] {
    -moz-appearance: textfield;
}
.qingdanheji {
    padding-top: 30px;
    font-size: 20px;
    div {
        margin-left: 10px;
        margin-right: 10px;
    }
}
</style>
